import React, { useContext, useEffect, useRef, useState } from "react";
import TailwindLayout from "TailwindcssComponents/TailwindLayout";
import TopBar from "TailwindcssComponents/TopBar";
import axios from "axios";
import moment from "moment";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { toast, ToastContainer } from "react-toastify";
import { json, useNavigate, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import CommonModel from "TailwindcssComponents/Models/commonModel";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import FooterTailwind from "TailwindcssComponents/Footer";
import { UserDataContext } from "context";
import SeatSetupModel from "./Models/seatSetupModel";
import SeatViewModel from "./Models/seatViewModel";

const AddEventNew = () => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem("token");
    const { userData, selectedOrganization } = useContext(UserDataContext);
    const userRole = userData?.isAdmin ? 'admin' : selectedOrganization?.name || 'user';
    const orgId = selectedOrganization?.organization?.id || null;
    const { id } = useParams();
    const [evId, setEvId] = useState(id || null);
    const [eventVenueId, setEventVenueId] = useState(null);
    const [selectedVenueZone, setSelectedVenueZone] = useState(null);
    const [isFreeEvent, setIsFreeEvent] = useState(true);
    const draftEventData = JSON.parse(localStorage.getItem('draftEvent')) || {};
    const [currentStep, setCurrentStep] = useState(1);
    const [categories, setCategories] = useState([]);
    const [venues, setVenues] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isEditLoading, setIsEditLoading] = useState(false);
    const [openDialogBox, setOpenDialogBox] = useState();
    const navigate = useNavigate();
    const [tickets, setTickets] = useState([{ id: "", name: "", price: "", discount: "", totalCount: "", closeDate: "", type: "regular", zoneId: selectedVenueZone?.id || '', eventId: evId, ticketCategoryImageUrl: null, points: 0, ticketCategoryImage: null, earlybirdCloseDate: '', earlybirdPrice: 0, earlybirdTotalCount: 0 }]);
    const [initialTickets, setInitialTickets] = useState([{ id: "", name: "", price: "", discount: "", totalCount: "", closeDate: "", type: "regular", zoneId: selectedVenueZone?.id || '', eventId: evId, points: 0, ticketCategoryImageUrl: null, earlybirdCloseDate: '', earlybirdPrice: 0, earlybirdTotalCount: 0 }]);
    const [isFirstStepLoading, setIsFirstStepLoading] = useState(false);
    const [isSecondStepLoading, setIsSecondStepLoading] = useState(false);
    const prevSlugRef = useRef("");
    const [seatSetupModelOpen, setSeatSetupModelOpen] = useState(false);
    const [seatViewModelOpen, setSeatViewModelOpen] = useState(false);
    const [seatsData, setSeatsData] = useState([]);
    const [ticketCatImageLoading, setTicketCatImageLoading] = useState(false);
    const [ticketCatAddLoading, setTicketCatAddLoading] = useState(false);
    const [ticketCatUpdateLoadingMap, setTicketCatUpdateLoadingMap] = useState({});
    const [ticketCatDeleteLoadingMap, setTicketCatDeleteLoadingMap] = useState({});
    const [initialSlug, setInitialSlug] = useState("");
    const [fetchedVenueZones, setFetchedVenueZones] = useState([]);
    const [eventZones, setEventZones] = useState([]);
    const [isSubEvent, setIsSubEvent] = useState(false);
    const [mainEvents, setMainEvents] = useState([]);
    const [coverImagePreview, setCoverImagePreview] = useState(null);
    const [featureImagePreview, setFeatureImagePreview] = useState(null);
    const [imagePreviews, setImagePreviews] = useState([]);
    const [existingImages, setExistingImages] = useState([]);

    const handleRemoveImage = (type, index = null) => {
        if (type === "coverImage") {
            newEvent.setFieldValue("coverImage", null);
            setCoverImagePreview(null);
        }

        if (type === "featureImage") {
            newEvent.setFieldValue("featureImage", null);
            setFeatureImagePreview(null);
        }

        if (type === "images" && index !== null) {
            const updated = [...imagePreviews];
            updated.splice(index, 1);
            setImagePreviews(updated);

            const updatedExistingImages = [...existingImages];
            updatedExistingImages.splice(index, 1); // Remove the object at the same index
            setExistingImages(updatedExistingImages);

            // Reflect changes in form values
            const updatedImages = updated.map(img => img.file || img.url);
            newEvent.setFieldValue("images", updatedImages);
        }
    };

    const handleCoverImageChange = (e) => {
        const file = e.currentTarget.files[0];
        if (file) {
            newEvent.setFieldValue("coverImage", file);
            setCoverImagePreview(URL.createObjectURL(file));
        }
    };

    const handleFeatureImageChange = (e) => {
        const file = e.currentTarget.files[0];
        if (file) {
            newEvent.setFieldValue("featureImage", file);
            setFeatureImagePreview(URL.createObjectURL(file));
        }
    };

    const handleOtherImagesChange = (e) => {
        const files = Array.from(e.currentTarget.files);
        const previews = files.map(file => ({
            url: URL.createObjectURL(file),
            file,
        }));

        const updatedPreviews = [...imagePreviews, ...previews];
        setImagePreviews(updatedPreviews);

        const updatedImages = updatedPreviews.map(img => img.file || img.url);
        newEvent.setFieldValue("images", updatedImages);
        // setExistingImages(prev => [...prev, ...files.map(file => ({ file}))]);
    };

    const addTicket = () => {
        const newTicket = {
            name: "",
            price: 0,
            discount: 0,
            totalCount: 0,
            closeDate: "",
            type: "regular",
            zoneId: selectedVenueZone?.id || '',
            eventId: evId,
            ticketCategoryImageUrl: null,
            points: 0,
            earlybirdCloseDate: null,
            earlybirdPrice: 0,
            earlybirdTotalCount: 0,
        };

        const updatedTickets = [...tickets, newTicket];
        setTickets(updatedTickets);
        newEvent.setFieldValue("tickets", updatedTickets);
    };

    const updateTicket = (index, field, value) => {
        const updatedTickets = tickets.map((ticket, i) =>
            i === index ? { ...ticket, [field]: value } : ticket
        );
        setTickets(updatedTickets);
        newEvent.setFieldValue(`tickets[${index}].${field}`, value);
        newEvent.setFieldTouched(`tickets[${index}].${field}`, true, false);
    };

    const removeTicket = (index) => {
        const updatedTickets = tickets.filter((_, i) => i !== index);
        setTickets(updatedTickets);
        newEvent.setFieldValue("tickets", updatedTickets);
    };

    const editTicketCategory = async (ticketCategory) => {
        const original = initialTickets.find(t => t.id === ticketCategory.id);
        if (!original) {
            return;
        }
        try {
            const singleTicketSchema = stepValidationSchemas[3].fields.tickets.innerType;
            await singleTicketSchema.validate(ticketCategory, { abortEarly: false });
        } catch (validationError) {
            if (validationError.name === "ValidationError") {
                console.warn("Validation errors:", validationError.errors);
                toast.error("Please fix the validation errors before updating the ticket.");
                return;
            }
        }
        try {
            setTicketCatUpdateLoadingMap((prev) => ({ ...prev, [id]: true }));
            const formDataPayload = new FormData();
            if (ticketCategory.name !== original.name) {
                formDataPayload.append("name", ticketCategory.name);
            }
            if (ticketCategory.type === "earlybird") {
                formDataPayload.append("earlybirdPrice", ticketCategory.earlybirdPrice);
                formDataPayload.append("earlybirdTotalCount", ticketCategory.earlybirdTotalCount);
                formDataPayload.append("earlybirdCloseDate", moment(ticketCategory.earlybirdCloseDate).format("YYYY-MM-DD"));
            }
            formDataPayload.append("type", ticketCategory.type);
            formDataPayload.append("price", ticketCategory.price);
            formDataPayload.append("discount", ticketCategory.discount);
            formDataPayload.append("totalCount", ticketCategory.totalCount);
            formDataPayload.append("points", ticketCategory.points);
            formDataPayload.append("closeDate", moment(ticketCategory.closeDate).format("YYYY-MM-DD"));
            formDataPayload.append("image", ticketCategory.ticketCategoryImage);
            const ticketCategoryResponse = await axios.put(`${apiUrl}event-service/ticket-category/${ticketCategory.id}`, formDataPayload, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${bearerToken}`,
                },
            });
            if (ticketCategoryResponse.data?.success) {
                toast.success("Ticket category has been successfully updated!");
            } else {
                throw new Error("Failed to update ticket category.");
            }
        }
        catch (error) {
            console.error("Error updating ticket category data:", error.message);
            toast.error("Something went wrong while updating the ticket.");
        } finally {
            setTicketCatUpdateLoadingMap((prev) => ({ ...prev, [id]: false }));
        }
    }

    const deleteTicketCategory = async (id) => {
        const original = initialTickets.find(t => t.id === id);
        if (!original) {
            return;
        }
        try {
            setTicketCatDeleteLoadingMap((prev) => ({ ...prev, [id]: true }));
            const ticketCategoryResponse = await axios.delete(`${apiUrl}event-service/ticket-category/${id}`, {
                headers: {
                    Authorization: `Bearer ${bearerToken}`,
                    "accept": "application/json",
                },
            });
            if (ticketCategoryResponse.data?.success) {
                const updatedTickets = tickets.filter((ticket) => ticket.id !== id);
                setTickets(updatedTickets);
                newEvent.setFieldValue("tickets", updatedTickets);
                toast.success("Ticket category has been successfully deleted!");
            } else {
                throw new Error("Failed to delete ticket category.");
            }
        }
        catch (error) {
            console.error("Error deleting ticket category data:", error.message);
        } finally {
            setTicketCatDeleteLoadingMap((prev) => ({ ...prev, [id]: false }));
        }
    }

    const addTicketCategory = async (ticketCategory) => {
        try {
            const ticketSchema = stepValidationSchemas[3].fields.tickets.innerType;
            await ticketSchema.validate(ticketCategory, { abortEarly: false });
        } catch (validationError) {
            if (validationError.name === "ValidationError") {
                console.warn("Validation failed:", validationError.errors);
                toast.error("Please fix the validation errors before submitting.");
                return;
            }
        }
        try {
            setTicketCatAddLoading(true);
            const formDataPayload = new FormData();
            if (ticketCategory.type === "earlybird") {
                formDataPayload.append("earlybirdPrice", ticketCategory.earlybirdPrice);
                formDataPayload.append("earlybirdTotalCount", ticketCategory.earlybirdTotalCount);
                formDataPayload.append("earlybirdCloseDate", moment(ticketCategory.earlybirdCloseDate).format("YYYY-MM-DD"));
            }
            formDataPayload.append("name", ticketCategory.name);
            formDataPayload.append("type", ticketCategory.type);
            formDataPayload.append("price", ticketCategory.price);
            formDataPayload.append("discount", ticketCategory.discount);
            formDataPayload.append("totalCount", ticketCategory.totalCount);
            formDataPayload.append("points", ticketCategory.points);
            formDataPayload.append("closeDate", moment(ticketCategory.closeDate).format("YYYY-MM-DD"));
            formDataPayload.append("eventId", evId);
            formDataPayload.append("zoneId", selectedVenueZone?.id);
            formDataPayload.append("image", ticketCategory.ticketCategoryImage);

            const ticketCategoryResponse = await axios.post(`${apiUrl}event-service/ticket-category`, formDataPayload, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${bearerToken}`,
                },
            });
            if (ticketCategoryResponse.data?.success) {
                toast.success("Ticket category has been successfully created!");
                const newTicket = { ...ticketCategory, id: ticketCategoryResponse.data.data.id };

                setTickets((prev) => {
                    const updated = [...prev];
                    updated[updated.length - 1] = newTicket;
                    return updated;
                });

                setInitialTickets((prev) => {
                    const updated = [...prev];
                    updated[updated.length - 1] = newTicket;
                    return updated;
                });
            } else {
                throw new Error("Failed to create ticket category.");
            }
        } catch (error) {
            console.error("Error adding ticket category:", error.message);
            toast.error("Something went wrong while creating the ticket.");
        } finally {
            setTicketCatAddLoading(false);
        }
    };

    const addTicketCategoryImage = async (ticketCategoryImage, index) => {
        try {
            setTicketCatImageLoading(true);
            const formData = new FormData();
            formData.append("image", ticketCategoryImage);

            const imageResponse = await axios.post(
                `${apiUrl}event-service/ticket-category/image`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${bearerToken}`,
                    },
                }
            );
            if (imageResponse.data?.success) {
                toast.success("Image has been successfully saved!");
                // Optionally update formik or state with the uploaded image URL or ID if needed
                newEvent.setFieldValue(`tickets[${index}].ticketCategoryImageUrl`, imageResponse.data.data.secure_url);
                setTickets(prevTickets =>
                    prevTickets.map((ticket, i) =>
                        i === index ? { ...ticket, ticketCategoryImageUrl: imageResponse.data.data.secure_url } : ticket
                    )
                );
            }
        } catch (error) {
            console.error("Error uploading image for ticket category:", error.message);
            toast.error("Failed to upload image. Please try again.");
        } finally {
            setTicketCatImageLoading(false);
        }
    };

    const handleAddDateAndTimeField = () => {
        newEvent.setFieldValue('eventDateTimes', [
            ...newEvent.values.eventDateTimes,
            { date: '', startTime: '', endTime: '' },
        ]);
    };

    const handleDeleteDateAndTimeField = (index) => {
        if (newEvent.values.eventDateTimes.length > 1) {
            const updated = [...newEvent.values.eventDateTimes];
            updated.splice(index, 1);
            newEvent.setFieldValue('eventDateTimes', updated);
        }
    };

    const handleDateTimeChange = (index, field, value) => {
        const updated = [...newEvent.values.eventDateTimes];
        updated[index][field] = value;

        // Time validation: endTime must be after startTime
        if (field === 'startTime' && updated[index].endTime) {
            if (updated[index].startTime >= updated[index].endTime) {
                updated[index].endTime = '';
            }
        }
        if (field === 'endTime' && updated[index].startTime) {
            if (updated[index].endTime <= updated[index].startTime) {
                return; // optional: skip setting invalid value
            }
        }
        newEvent.setFieldValue('eventDateTimes', updated);
    };

    const fetchData = async () => {
        try {
            const [organizationRes, categoryRes, venueRes, allEventsResponse] = await Promise.all([
                axios.get(`${apiUrl}auth-service/org?isArchived=false`, { headers: { Authorization: `Bearer ${bearerToken}` } }),
                axios.get(`${apiUrl}event-service/event-category`),
                axios.get(`${apiUrl}event-service/event-venue`),
                axios.get(`${apiUrl}event-service/event`),
            ]);
            setOrganizations(organizationRes.data?.data || []);
            setCategories(categoryRes.data?.data || []);
            setVenues(venueRes.data?.data || []);
            setMainEvents(allEventsResponse.data?.data || []);
        } catch (error) {
            console.error(error.message);
        }
    };

    const mergeZonesById = (existingZones, newZones) => {
        const zoneMap = new Map();

        // First, populate the map with existing zones
        existingZones.forEach(z => zoneMap.set(z.id, z));

        // Then, update or add zones from newZones
        newZones?.forEach(z => zoneMap.set(z.id, z));

        // Return the merged zones as an array
        return Array.from(zoneMap.values());
    };

    const fetchSingleEventData = async () => {
        try {
            setIsEditLoading(true);
            const [eventRes, organizationRes, categoryRes, venueRes, ticketcategoryRes, eventZoneRes, allEventsResponse] = await Promise.all([
                axios.get(`${apiUrl}event-service/event/${evId}`),
                axios.get(`${apiUrl}auth-service/org?isArchived=false`, { headers: { Authorization: `Bearer ${bearerToken}` } }),
                axios.get(`${apiUrl}event-service/event-category`),
                axios.get(`${apiUrl}event-service/event-venue`),
                axios.get(`${apiUrl}event-service/ticket-category`, { params: { event: evId } }),
                axios.get(`${apiUrl}event-service/event-zone`, { params: { event: evId } }),
                axios.get(`${apiUrl}event-service/event`),
            ]);

            const event = eventRes?.data?.data;
            setEventVenueId(event?.venueId || null);
            setIsSubEvent(event?.mainEventId ? true : false);
            const ticketCategory = ticketcategoryRes?.data?.data || null;
            const eventZones = eventZoneRes?.data?.data || null;
            setEventZones(prev => mergeZonesById(prev, eventZones));

            if (event) {
                Object.entries(event).forEach(([key, value]) => {
                    if (['registrationOpenDate', 'registrationCloseDate'].includes(key)) {
                        value = moment.utc(value);
                    }
                    if (key === 'tags' && value) {
                        if (typeof value === 'string') {
                            value = value
                                .split(',')
                                .map(tag => tag.trim())
                                .filter(tag => tag); // Remove empty strings
                        }
                    }
                    if (key === 'coverImage' && value) {
                        value = value.secure_url; // Assign image URL
                        setCoverImagePreview(value); // Set preview for cover image
                    }
                    if (key === 'featureImage' && value) {
                        value = value.secure_url;
                        setFeatureImagePreview(value); // Set preview for feature image
                    }
                    if (key === 'images' && Array.isArray(value)) {
                        setExistingImages(value); // Store existing images for reference
                        value = value.map(img => img.secure_url); // Assign array of image URLs
                        setImagePreviews(value.map(url => ({ url, file: null }))); // Set previews for images
                    }
                    if (key === 'eventDateTimes' && Array.isArray(value)) {
                        value = value.map(entry => ({
                            id: entry.id || "",
                            date: moment(entry.date).toDate(), // Convert ISO string to Date object
                            startTime: moment(entry.startTime, "HH:mm:ss").toDate(),
                            endTime: moment(entry.endTime, "HH:mm:ss").toDate(),
                        }));
                    }
                    newEvent.setFieldValue(key, value);
                });
                setInitialSlug(event.slug);

                if (!event.isFree) {
                    newEvent.setFieldValue('ticketType', ticketCategory ? "Ticketed Event" : "Free Event");
                    newEvent.setFieldValue('isFree', false);
                    setIsFreeEvent(false);
                } else if (event.isFree) {
                    newEvent.setFieldValue('ticketType', "Free Event");
                    newEvent.setFieldValue('isFree', true);
                    setIsFreeEvent(true);
                }
            }

            if (ticketCategory) {
                const mappedTicketCategory = (ticketCategory && ticketCategory.length > 0)
                    ? ticketCategory.map(({ id, name, price, discount, totalCount, closeDate, type, zoneId, points, earlybirdPrice, earlybirdTotalCount, earlybirdCloseDate, image }) => ({
                        id,
                        name,
                        price,
                        discount,
                        totalCount,
                        closeDate: new Date(closeDate),
                        type,
                        zoneId: zoneId || selectedVenueZone?.id,
                        eventId: evId,
                        points,
                        earlybirdPrice,
                        earlybirdTotalCount,
                        earlybirdCloseDate: new Date(earlybirdCloseDate),
                        ticketCategoryImage: image || null,
                        ticketCategoryImageUrl: image?.secure_url || null,
                    }))
                    : tickets; // fallback to existing default state

                // Set the tickets in Formik in a single call for the entire array
                setTickets(mappedTicketCategory);
                setInitialTickets(mappedTicketCategory);

                // You can set the Formik initial values for all tickets in one go using setFieldValue
                newEvent.setFieldValue('tickets', mappedTicketCategory);
            }

            if (eventZones) {
                Object.entries(eventZones).forEach(([key, value]) => {
                    newEvent.setFieldValue(
                        key === "name" ? "zoneName" :
                            key === "capacity" ? "capacity" :
                                key === "isSeat" ? "isSeat" :
                                    key === "totalSeatsPerRows" ? "totalSeatsPerRows" :
                                        key === "totalRows" ? "totalRows" :
                                            key,
                        value
                    );
                });
                const mappedValues = Object.entries(eventZones).reduce((acc, [key, value]) => {
                    acc[
                        key === "name" ? "zoneName" :
                            key === "capacity" ? "capacity" :
                                key === "isSeat" ? "isSeat" :
                                    key === "totalSeatsPerRows" ? "totalSeatsPerRows" :
                                        key === "totalRows" ? "totalRows" :
                                            key
                    ] = value;
                    return acc;
                }, {});

            }
            setOrganizations(organizationRes?.data?.data || []);
            setCategories(categoryRes?.data?.data || []);
            setVenues(venueRes?.data?.data || []);
            setMainEvents(allEventsResponse.data?.data || []);
        } catch (error) {
            console.error('Error fetching single event data:', error.message);
        } finally {
            setIsEditLoading(false);
        }
    };

    const fetchVenueZonesWithSeats = async () => {
        if (!eventVenueId) return;

        try {
            const [zonesResponse, seatsResponse] = await Promise.all([
                axios.get(`${apiUrl}event-service/venue-zone`, {
                    params: { venue: eventVenueId }
                }),
                axios.get(`${apiUrl}event-service/venue-seat`, {
                    params: { venue: eventVenueId }
                })
            ]);

            const zonesSuccess = zonesResponse.data?.success;
            const seatsSuccess = seatsResponse.data?.success;

            if (!zonesSuccess || !seatsSuccess) {
                throw new Error(
                    zonesResponse.data?.message || seatsResponse.data?.message || 'Error fetching venue data'
                );
            }

            const zones = zonesResponse.data.data || [];
            const rawSeats = seatsResponse.data.data || [];

            // Group seats by zoneId
            const seatsGroupedByZone = rawSeats.reduce((acc, seat) => {
                const { zoneId } = seat;
                if (!acc[zoneId]) acc[zoneId] = [];
                acc[zoneId].push(seat);
                return acc;
            }, {});

            // Merge: Attach seats to corresponding zones
            const enrichedZones = zones.map(zone => ({
                ...zone,
                seats: seatsGroupedByZone[zone.id] || []
            }));

            setFetchedVenueZones(prev => mergeZonesById(prev, enrichedZones));
        } catch (error) {
            console.error(error.response?.data?.message || error.message);
        }
    };

    useEffect(() => {
        fetchVenueZonesWithSeats();
    }, [eventVenueId]);

    useEffect(() => {
        // Reset Form to default values
        const fetchDataBasedOnId = async () => {
            if (evId) {
                await fetchSingleEventData();
            } else {
                await fetchData();
            }
        };
        fetchDataBasedOnId();
    }, [evId]);

    const saveZone = async (values) => {
        const {
            zoneName,
            capacity,
            isSeat: rawIsSeat,
            totalRows = 0,
            totalSeatsPerRows = 0
        } = values;
        const isSeat = JSON.parse(rawIsSeat?.toString().toLowerCase() || 'false');
        if (!zoneName || !capacity) {
            toast.error("Zone name and capacity are required.");
            return;
        }

        setIsSecondStepLoading(true);
        const zoneOnlySchema = stepValidationSchemas[3].omit(['tickets']);
        await zoneOnlySchema.validate(newEvent.values, { abortEarly: false });
        try {
            const formData = new URLSearchParams({
                name: zoneName,
                capacity: capacity.toString(),
                isSeat: isSeat.toString(),
                totalRows: isSeat ? totalRows.toString() : "0",
                totalSeatsPerRows: isSeat ? totalSeatsPerRows.toString() : "0",
                eventId: evId
            });

            const response = await axios.post(
                `${apiUrl}event-service/event-zone`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${bearerToken}`,
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                }
            );

            const responseData = response.data?.data;
            const success = response.data?.success;

            if (!success || !responseData?.id) {
                throw new Error(response.data?.message || "Error saving event zone.");
            }

            toast.success("Event Zone has been successfully created!");

            const eventZoneId = responseData.id;

            // Handle seat data if the zone is a seating zone
            if (isSeat) {
                const sourceSeats = seatsData?.seats?.length > 0
                    ? seatsData.seats
                    : selectedVenueZone?.seats || [];

                const formattedSeats = sourceSeats.map(({ name, row, column }) => ({
                    name,
                    row,
                    column,
                    zoneId: eventZoneId,
                    eventId: evId
                }));

                if (formattedSeats.length > 0) {
                    await axios.post(
                        `${apiUrl}event-service/event-seat/bulk`,
                        { eventId: evId, seats: formattedSeats },
                        {
                            headers: {
                                Authorization: `Bearer ${bearerToken}`
                            }
                        }
                    );
                }
            }

            resetZoneForm(); // Reset your form state here

        } catch (error) {
            const errorMsg = error.response?.data?.message || error.message;
            console.error("Save failed:", errorMsg);
            toast.error(`Save failed: ${errorMsg}`);
        } finally {
            const fetchEventZones = await axios.get(`${apiUrl}event-service/event-zone`, { params: { event: evId || id } });
            setEventZones(fetchEventZones.data?.data || []);
            setIsSecondStepLoading(false);
            setSeatsData([]);
        }
    };

    const resetZoneForm = () => {
        setSelectedVenueZone(null);
        newEvent.setValues({
            ...newEvent.values,
            zoneName: "",
            capacity: "",
            isSeat: "false",
            totalRows: "",
            totalSeatsPerRows: "",
        });
    };

    const updateZone = async ({ zoneName, capacity, isSeat, totalRows, totalSeatsPerRows }) => {
        if (!zoneName || !capacity) {
            toast.error("Zone name and capacity are required.");
            return;
        }
        if (!selectedVenueZone) {
            toast.error("A zone should be selected.");
            return;
        }

        try {
            const zoneOnlySchema = stepValidationSchemas[3].omit(['tickets']);
            await zoneOnlySchema.validate(newEvent.values, { abortEarly: false });
        } catch (validationError) {
            if (validationError.name === "ValidationError") {
                console.warn("Validation failed:", validationError.errors);
                toast.error("Please fix the validation errors before submitting.");
                return;
            }
        }

        setIsSecondStepLoading(true);
        try {
            const formData = new URLSearchParams();
            const currentZone = eventZones.find(z => z.id === selectedVenueZone.id);
            if (!currentZone) {
                toast.error("Current zone data not found.");
                return;
            }
            if (zoneName !== currentZone.name) {
                formData.append("name", zoneName);
            }
            formData.append("capacity", capacity.toString());
            formData.append("isSeat", isSeat.toString());
            formData.append("totalRows", isSeat ? totalRows.toString() : "0");
            formData.append("totalSeatsPerRows", isSeat ? totalSeatsPerRows.toString() : "0");
            formData.append("eventId", evId);

            const response = await axios.put(
                `${apiUrl}event-service/event-zone/${selectedVenueZone.id}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${bearerToken}`,
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                }
            );

            if (response.data?.success) {
                toast.success("Event Zone has been successfully updated!");
            } else {
                throw new Error(response.data?.message || "Error updating event zone.");
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || error.message;
            console.error("Update failed:", errorMsg);
            toast.error(`Update failed: ${errorMsg}`);
        } finally {
            setIsSecondStepLoading(false);
            setSeatsData([]);
            fetchSingleEventData();
        }
    };

    const stepValidationSchemas = [
        Yup.object().shape({
            name: Yup.string().required("Event name is required"),
            slug: Yup.string().required("Slug is required"),
            description: Yup.string().required("Description is required"),
            contactEmail: Yup.string()
                .required("Required")
                .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Enter a valid email")
                .email("Enter a valid email"),
            contactPhone: Yup.string()
                .required("Required")
                .matches(/^\+94\d{9}$/, "Phone number must start with +94 and contain 9 digits after it")
                .length(12, "Phone number must be exactly 12 characters"),
            categoryId: Yup.string().required("Category is required"),
            venueId: Yup.string().required("Venue is required"),
            orgId: Yup.string().required("Organization is required"),
            registrationOpenDate: Yup.date().required("Registration openeing date is required"),
            registrationCloseDate: Yup.date().required("Registration closing date is required"),
            trailer: Yup.string().nullable().notRequired()
                .url('Please enter a valid URL')
                .when('$isTrailerProvided', {
                    is: (value) => !!value, // only run .matches() if value exists
                    then: (schema) =>
                        schema.matches(/\/embed\//, 'Please enter a valid embedded video URL (must contain "/embed/")'),
                }),
            eventDateTimes: Yup.array().of(
                Yup.object().shape({
                    date: Yup.string().required("Date is required"),
                    startTime: Yup.string().required("Start time is required"),
                    endTime: Yup.string()
                        .required("End time is required")
                        .test("is-after-start", "End time must be after start time", function (value) {
                            const { startTime } = this.parent;
                            return !startTime || !value || value > startTime;
                        })
                })
            )
        }),
        Yup.object().shape({
            coverImage: Yup.mixed()
                .nullable()
                .notRequired()
                .test("validCoverImage", "Invalid cover image", (value) => {
                    if (!value) return true; // Not required
                    if (typeof value === "object") return true; // File object (new upload)
                    if (typeof value === "string" && value.startsWith("http")) return true; // Existing image URL
                    return false;
                })
                .test("fileType", "Only image files are allowed", (value) => {
                    if (!value || typeof value === "string") return true; // Allow existing image URLs or empty
                    return ["image/jpeg", "image/png", "image/gif"].includes(value.type);
                })
                .test("fileSize", "File size must be less than 1MB", (value) => {
                    if (!value || typeof value === "string") return true; // Allow existing URLs or no file
                    return value.size <= 1 * 1024 * 1024;
                }),
            images: Yup.array()
                .nullable()
                .notRequired()
                .test("validImages", "Invalid image(s) in array", (value) => {
                    if (!value) return true; // Not required
                    return value.every(
                        (img) =>
                            typeof img === "object" ||
                            (typeof img === "string" && img.startsWith("http"))
                    );
                })
                .test("fileSize", "Each file must be less than 1MB", (value) => {
                    if (!value) return true; // Not required
                    return value.every((img) => {
                        if (typeof img === "string") return true; // Existing URL
                        return img.size <= 1 * 1024 * 1024;
                    });
                }),
            featureImage: Yup.mixed()
                .nullable()
                .notRequired()
                .test("validFeatureImage", "Invalid feature image", (value) => {
                    if (!value) return true; // Not required
                    if (typeof value === "object") return true; // File object (new upload)
                    if (typeof value === "string" && value.startsWith("http")) return true; // Existing image URL
                    return false;
                })
                .test("fileType", "Only image files are allowed", (value) => {
                    if (!value || typeof value === "string") return true; // Allow existing image URLs or empty
                    return ["image/jpeg", "image/png", "image/gif"].includes(value.type);
                })
                .test("fileSize", "File size must be less than 1MB", (value) => {
                    if (!value || typeof value === "string") return true; // Allow existing URLs or no file
                    return value.size <= 1 * 1024 * 1024;
                }),
        }),
        Yup.object().shape({
            zoneName: Yup.string().required("Zone name is required"),
            capacity: Yup.number().required("Capacity is required").min(1, "Capacity must be at least 1"),
            isSeat: Yup.boolean().required("Is Seat is required"),
        }),
        Yup.object().shape({
            zoneName: Yup.string().required("Zone name is required"),
            capacity: Yup.number().required("Capacity is required").min(1, "Capacity must be at least 1"),
            isSeat: Yup.boolean().required("Is Seat is required"),
            // totalRows: Yup.number().when("isSeat", {
            //     is: true,
            //     then: Yup.number().required("Total Rows is required").min(1, "Total Rows must be at least 1"),
            //     otherwise: Yup.number().nullable(),
            // }),
            // totalSeatsPerRows: Yup.number().when("isSeat", {
            //     is: true,
            //     then: Yup.number().required("Total Seats Per Row is required").min(1, "Total Seats Per Row must be at least 1"),
            //     otherwise: Yup.number().nullable(),
            // }),
            tickets: Yup.array()
                .of(
                    Yup.object().shape({
                        name: Yup.string()
                            .required("Ticket name is required")
                            .test("unique-name", "Ticket name must be unique", function (value) {
                                const { tickets } = this.options.context; // Get the current tickets array
                                if (!tickets) return true;
                                const nameCount = tickets.filter((t) => t.name === value).length;
                                return nameCount <= 1;
                            }),
                        price: Yup.number().min(1, "Price must be at least 1").notRequired(),
                        discount: Yup.number().min(0, "Discount cannot be negative").notRequired(),
                        points: Yup.number().min(0, "Points cannot be negative").notRequired(),
                        earlybirdPrice: Yup.number().min(0, "Price cannot be negative").notRequired(),
                        earlybirdTotalCount: Yup.number().min(0, "Total Count cannot be negative").notRequired(),
                        earlybirdCloseDate: Yup.date(),
                        totalCount: Yup.number().required("Total Count is required").min(1, "Total must be at least 1"),
                        closeDate: Yup.date()
                            .required("Closing Date is required")
                            .typeError("Closing Date must be a valid date"),
                    })
                )
                .test("unique-tickets", "Duplicate ticket names are not allowed", function (tickets) {
                    if (!tickets) return true;
                    const names = tickets.map((ticket) => ticket.name);
                    return new Set(names).size === names.length; // Ensures all names are unique
                }),
        }),

    ];

    const newEvent = useFormik({
        initialValues: {
            isCompetition: false,
            name: "",
            contactEmail: "",
            contactPhone: "",
            status: null,
            categoryId: "",
            venueId: "",
            orgId: orgId || '',
            description: "",
            coverImage: null,
            images: null,
            featureImage: null,
            updateImages: null,
            tags: "",
            trailer: "",
            isFree: true,
            registrationOpenDate: null,
            registrationCloseDate: null,
            ticketType: "Free Event",
            ticketCategory: "",
            ticketName: "",
            ticketPrice: "",
            totalCount: "",
            closeDate: null,
            date: null,
            startTime: null,
            endTime: null,
            isSingleRegistrationPerTicket: true,
            ticketPurchaseLimit: 1,
            discount: 0,
            zoneId: "",
            totalRows: "",
            totalSeatsPerRows: "",
            capacity: "",
            isSeat: false,
            zoneName: "",
            capacity: "",
            slug: "",
            mainEventId: "",
            tickets: [
                {
                    name: '',
                    price: '',
                    discount: '',
                    totalCount: '',
                    type: 'regular',
                    closeDate: null,
                    ticketCategoryImageUrl: null,
                    ticketCategoryImage: null,
                    points: 0,
                    earlybirdPrice: 0,
                    earlybirdTotalCount: 0,
                    earlybirdCloseDate: null,
                }
            ],
            eventDateTimes: [
                { date: '', startTime: '', endTime: '' }
            ],
            venueZones: [
                {
                    zoneName: "",
                    capacity: "",
                    isSeat: "false",
                    totalRows: "",
                    totalSeatsPerRows: ""
                }
            ],
        },
        validateOnChange: true,
        validateOnBlur: true,
        enableReinitialize: true,
        validationSchema: stepValidationSchemas[currentStep - 1],
        onSubmit: async (values, { resetForm }) => {
            if (!id) {
                try {
                    setLoading(true);
                    const formData = new FormData();
                    formData.append("status", "published");
                    formData.append("ticketPurchaseLimit", values.ticketPurchaseLimit);
                    formData.append("isFree", isFreeEvent);

                    const response = await axios.put(`${apiUrl}event-service/event/${evId}`, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: `Bearer ${bearerToken}`,
                        },
                    });

                    if (!response.data?.success) {
                        throw new Error("Failed to publish event.");
                    }
                    toast.success("Event has been successfully published!");
                    resetForm();
                    setTimeout(() => {
                        navigate("/events/view-events");
                        setCurrentStep(1);
                    }, 500);

                } catch (error) {
                    console.error("Error publishing event:", error);
                    const errorMessage = error?.response?.data?.message || error.message || "An error occurred.";
                    toast.error(`Failed to publish the event: ${errorMessage}`);
                } finally {
                    setLoading(false);
                }

            }
            else if (id) {
                try {
                    setLoading(true);
                    const formDataPayload = new FormData();
                    formDataPayload.append("status", "published");
                    formDataPayload.append("ticketPurchaseLimit", values.ticketPurchaseLimit);
                    formDataPayload.append("isSingleRegistrationPerTicket", String(values.isSingleRegistrationPerTicket));
                    formDataPayload.append("isFree", isFreeEvent);
                    const eventResponse = await axios.put(`${apiUrl}event-service/event/${id}`, formDataPayload, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: `Bearer ${bearerToken}`,
                        },
                    });
                    if (eventResponse.data?.success) {
                        resetForm();
                        navigate('/events/view-events');
                        setTimeout(() => {
                            toast.success(eventResponse.data?.message || 'Event has been successfully updated!');
                            setCurrentStep(1);
                        }, 500)
                    } else {
                        throw new Error('Failed to update event');
                    }
                } catch (error) {
                    console.error("Error updating event:", error.message, error.eventResponse?.data || error);
                    toast.error("Failed to edit the event." || error.eventResponse?.data);
                } finally {
                    setLoading(false);
                }
            }

        },
    });

    useEffect(() => {
        if (Object.keys(newEvent.errors).length > 0 && newEvent.submitCount > 0) {
            const errorField = document.querySelector(`[name="${Object.keys(newEvent.errors)[0]}"]`);
            errorField?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            errorField?.focus();
        }
    }, [newEvent.errors, newEvent.submitCount]);

    const handleNext = async (event) => {
        event.preventDefault();
        try {
            validateSlug(newEvent.values.slug, newEvent.setFieldError, newEvent.setFieldTouched);
            newEvent.setErrors({});
            await stepValidationSchemas[currentStep - 1].validate(newEvent.values, { abortEarly: false });
            if (currentStep === 1 && !evId) {
                try {
                    setIsFirstStepLoading(true);
                    const formDataPayload = new FormData();
                    Object.entries(newEvent.values).forEach(([key, value]) => {
                        if (key === "tags") {
                            const tagsArray = value.split(",").map((tag) => tag.trim());
                            formDataPayload.append(key, JSON.stringify(tagsArray));
                        } else if (["registrationOpenDate", "registrationCloseDate",].includes(key)) {
                            formDataPayload.append(key, moment(value).format("YYYY-MM-DD HH:mm:ss"));
                        } else if (["date"].includes(key)) {
                            formDataPayload.append(key, moment(value).format("YYYY-MM-DD"));
                        } else if (["startTime", "endTime"].includes(key)) {
                            formDataPayload.append(key, moment(value).format("HH:mm"));
                        } else if (key === "eventDateTimes") {
                            const formatted = value?.map(entry => ({
                                date: moment(entry.date).format("YYYY-MM-DD"),
                                startTime: moment(entry.startTime).format("HH:mm"),
                                endTime: moment(entry.endTime).format("HH:mm"),
                            }));
                            formDataPayload.append(key, JSON.stringify(formatted));
                        } else if (key === "trailer" && value === null) {
                            formDataPayload.append(key, "");
                        } else if (key === "trailer" && value !== null) {
                            formDataPayload.append(key, value);
                        } else if (key === "mainEventId") {
                            const mainEventValue = isSubEvent ? value : '';
                            formDataPayload.append(key, mainEventValue);
                        } else if (value !== null && value !== undefined) {
                            formDataPayload.append(key, value.toString());
                        }
                    });
                    formDataPayload.append("status", "draft");
                    const eventResponse = await axios.post(`${apiUrl}event-service/event`, formDataPayload, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: `Bearer ${bearerToken}`,
                        },
                    });

                    if (eventResponse.data?.success) {
                        setEvId(eventResponse.data?.data?.id);
                        setCurrentStep(2);
                    } else {
                        throw new Error("Failed to continue.");
                    }
                } catch (error) {
                    console.error("Error saving draft:", error);
                    toast.error("Failed to continue.");
                } finally {
                    setIsFirstStepLoading(false);
                }
            }

            if (currentStep === 1 && (evId || id)) {
                try {
                    setIsFirstStepLoading(true);
                    const allowedKeys = [
                        "name", "contactEmail", "contactPhone", "categoryId", "venueId", "mainEventId",
                        "trailer", "slug", "description", "tags", "isFree", "registrationOpenDate",
                        "registrationCloseDate", "orgId",
                        "isSingleRegistrationPerTicket", "ticketPurchaseLimit", "eventDateTimes"
                    ];
                    const formDataPayload = new FormData();
                    Object.entries(newEvent.values).forEach(([key, value]) => {
                        if (!allowedKeys.includes(key)) return; // Ignore unwanted keys

                        if (key === "tags") {
                            formDataPayload.append(key, [""]);
                            // const tagsArray = value.split(",").map((tag) => tag.trim());
                            // formDataPayload.append(key, JSON.stringify(tagsArray));
                        } else if (["registrationOpenDate", "registrationCloseDate"].includes(key)) {
                            formDataPayload.append(key, moment(value).format("YYYY-MM-DD HH:mm:ss"));
                        } else if (["name", "contactEmail", "contactPhone", "categoryId",
                            "venueId", "slug", "description", "orgId"].includes(key)) {
                            formDataPayload.append(key, value);
                        } else if (key === "isFree" || key === "isSingleRegistrationPerTicket") {
                            formDataPayload.append(key, JSON.stringify(value));
                        } else if (key === "ticketPurchaseLimit") {
                            formDataPayload.append(key, parseInt(value, 10));
                        } else if (key === "trailer" && value === null) {
                            formDataPayload.append(key, "");
                        } else if (key === "trailer" && value !== null) {
                            formDataPayload.append(key, value);
                        } else if (key === "eventDateTimes") {
                            const formatted = value?.map(entry => ({
                                id: entry.id || "",
                                date: moment(entry.date).format("YYYY-MM-DD"),
                                startTime: moment(entry.startTime).format("HH:mm"),
                                endTime: moment(entry.endTime).format("HH:mm"),
                            }));
                            formDataPayload.append(key, JSON.stringify(formatted));
                        } else if (key === "mainEventId") {
                            const mainEventValue = isSubEvent ? value : '';
                            formDataPayload.append(key, mainEventValue);
                        }
                    });
                    const eventResponse = await axios.put(`${apiUrl}event-service/event/${evId}`, formDataPayload, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: `Bearer ${bearerToken}`,
                        },
                    });

                    if (eventResponse.data?.success) {
                        setEvId(eventResponse.data?.data?.id);
                        setCurrentStep(2);
                    } else {
                        throw new Error("Failed to save draft.");
                    }
                } catch (error) {
                    console.error("Error saving draft:", error);
                    toast.error("Failed to save draft.");
                } finally {
                    setIsFirstStepLoading(false);
                }
            }

            if (currentStep === 2 && (evId || id)) {
                try {
                    setIsSecondStepLoading(true);
                    const formDataPayload = new FormData();
                    Object.entries(newEvent.values).forEach(([key, value]) => {
                        if (key === "images" && Array.isArray(value)) {
                            value.forEach((image) => formDataPayload.append(key, image));
                        }
                        if (key === "coverImage" && value) {
                            formDataPayload.append(key, value);
                        }
                        if (key === "featureImage" && value) {
                            formDataPayload.append(key, value);
                        }
                    });
                    if (existingImages) {
                        formDataPayload.append("updateImages", JSON.stringify(existingImages));
                    }
                    const eventResponse = await axios.put(`${apiUrl}event-service/event/${evId}`, formDataPayload, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: `Bearer ${bearerToken}`,
                        },
                    });

                    if (eventResponse.data?.success) {
                        setCurrentStep(3);
                    } else {
                        throw new Error("Failed to update event with images.");
                    }
                } catch (error) {
                    console.error("Error updating event:", error);
                    toast.error("Failed to update event with images.");
                } finally {
                    setIsSecondStepLoading(false);
                }
            }

        } catch (validationErrors) {
            const errors = validationErrors.inner.reduce((acc, error) => {
                acc[error.path] = error.message;
                return acc;
            }, {});
            // // Mark all fields that failed validation as touched
            const touchedFields = validationErrors.inner.reduce((acc, error) => {
                acc[error.path] = true;
                return acc;
            }, {});
            newEvent.setTouched(touchedFields);
            newEvent.setErrors(errors);
            toast.error("Please fill required fields with valid inputs");
        }
    };

    const handlePrevious = () => {
        setCurrentStep((prev) => Math.max(prev - 1, 1));
    };

    useEffect(() => {
        if (newEvent.values.name) {
            const slug = newEvent.values.name
                .toLowerCase()
                .replace(/\s+/g, '-') // Replace spaces with hyphens
                .replace(/[^a-z0-9-]/g, '') // Remove non-alphanumeric characters except hyphens
                .trim();

            newEvent.setFieldValue("slug", slug);

            if (slug && slug !== prevSlugRef.current) {
                // Debounced validation
                const timeout = setTimeout(() => {
                    validateSlug(slug, newEvent.setFieldError, newEvent.setFieldTouched);
                    prevSlugRef.current = slug; // Update the previous slug
                }, 100);

                return () => clearTimeout(timeout); // Cleanup on slug change
            }
        }
    }, [newEvent.values.name]);

    const validateSlug = async (slug, setFieldError, setFieldTouched) => {
        if (!slug || (id && slug === initialSlug)) return; // Skip validation if slug is empty
        setFieldTouched("slug", true);
        try {
            const response = await axios.get(`${apiUrl}event-service/event/check-slug/${slug}`);

            // If success = false, display API message as error
            if (!response.data.success) {
                setFieldError("slug", response.data.message || "Slug is not available");
            }
        } catch (error) {
            // Handle 400 error specifically (Slug already taken)
            if (error.response && error.response.status === 400) {
                setFieldError("slug", error.response.data.message || "Slug already taken");
            } else {
                setFieldError("slug", "Error validating slug. Please try again.");
            }
        }
    };

    const openSeatSetupModel = () => {
        setSeatSetupModelOpen(true);
    }

    const closeSeatSetupModel = () => {
        setSeatSetupModelOpen(false);
    };

    const openSeatViewModel = () => {
        setSeatViewModelOpen(true);
    }

    const closeSeatViewModel = () => {
        setSeatViewModelOpen(false);
    };

    const renderStepContent = () => {
        switch (currentStep) {
            case 1:
                return (
                    <div className="max-w-full">
                        <h2 className="text-lg font-medium mb-8">Event Details</h2>
                        <div className="space-y-6">
                            {/*Type Selection */}
                            {!evId && (
                                <div className="grid md:grid-cols-2 gap-6 mb-6">
                                    {/* Event*/}
                                    <div
                                        className={`border-2 rounded-xl p-6 transition-all duration-200 cursor-pointer shadow-sm hover:shadow-md ${!(newEvent.values.isCompetition) ? "border-blue-300 bg-blue-50" : "border-gray-200 hover:border-blue-300"}`}
                                        onClick={() => {
                                            newEvent.setFieldValue("isCompetition", false);
                                            // setIsFreeEvent(false);
                                        }}
                                    >
                                        <div className="flex items-center justify-center mb-4">
                                            <Icon icon="material-symbols-light:event-outline" className="text-5xl text-blue-500" />
                                        </div>
                                        <h3 className="text-center text-sm font-medium mb-2">Event</h3>
                                        <p className="text-sm text-center text-gray-600">Organize a regular event like a concert, seminar, or gathering.</p>
                                    </div>

                                    {/*Competition*/}
                                    <div
                                        className={`border-2 rounded-xl p-6 transition-all duration-200 cursor-pointer shadow-sm hover:shadow-md ${newEvent.values.isCompetition ? "border-blue-300 bg-blue-50" : "border-gray-200 hover:border-blue-300"}`}
                                        onClick={() => {
                                            newEvent.setFieldValue("isCompetition", true);
                                            // setIsFreeEvent(true);
                                        }}
                                    >
                                        <div className="flex items-center justify-center mb-4">
                                            <Icon icon="streamline-cyber:trophy-4" className="text-5xl text-blue-500" />
                                        </div>
                                        <h3 className="text-center text-sm font-medium mb-2">Competition</h3>
                                        <p className="text-sm text-center text-gray-600">Set up a competitive event such as a contest, pitching, or quiz.</p>
                                    </div>
                                </div>
                            )}

                            <div>
                                <label className="block text-sm font-medium mb-2">
                                    Title <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    value={newEvent.values.name}
                                    onChange={newEvent.handleChange}
                                    onBlur={newEvent.handleBlur}
                                    placeholder="Event Title"
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                />
                                {newEvent.touched.name && newEvent.errors.name && <div className="text-red-500">{newEvent.errors.name}</div>}
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-2">
                                    Unique Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="slug"
                                    value={newEvent.values.slug}
                                    onChange={newEvent.handleChange}
                                    onBlur={() => validateSlug(newEvent.values.slug, newEvent.setFieldError, newEvent.setFieldTouched)}
                                    placeholder="event-name"
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                />
                                {newEvent.touched.slug && newEvent.errors.slug && <div className="text-red-500">{newEvent.errors.slug}</div>}
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-2">
                                    Contact Email <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="email"
                                    name="contactEmail"
                                    value={newEvent.values.contactEmail}
                                    onChange={newEvent.handleChange}
                                    onBlur={newEvent.handleBlur}
                                    placeholder="e.g. abc@zmail.com"
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                />
                                {newEvent.touched.contactEmail && newEvent.errors.contactEmail && <div className="text-red-500">{newEvent.errors.contactEmail}</div>}
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-2">
                                    Contact Phone <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="contactPhone"
                                    value={newEvent.values.contactPhone}
                                    onChange={newEvent.handleChange}
                                    onBlur={newEvent.handleBlur}
                                    placeholder="e.g. +94712345678"
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                />
                                {newEvent.touched.contactPhone && newEvent.errors.contactPhone && <div className="text-red-500">{newEvent.errors.contactPhone}</div>}
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-2">
                                    Category <span className="text-red-500">*</span>
                                </label>
                                <select
                                    name="categoryId"
                                    value={newEvent.values.categoryId}
                                    onChange={newEvent.handleChange}
                                    onBlur={newEvent.handleBlur}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                >
                                    <option value="" disabled>
                                        Select Category
                                    </option>
                                    {categories.map((category) => (
                                        <option key={category.id} value={category.id}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                                {newEvent.touched.categoryId && newEvent.errors.categoryId && <div className="text-red-500">{newEvent.errors.categoryId}</div>}
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-2">
                                    Venue <span className="text-red-500">*</span>
                                </label>
                                <select
                                    name="venueId"
                                    value={newEvent.values.venueId}
                                    onChange={(e) => {
                                        newEvent.handleChange(e);
                                        setEventVenueId(e.target.value);
                                    }}
                                    onBlur={newEvent.handleBlur}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                >
                                    <option value="" disabled>
                                        Select Venue
                                    </option>
                                    {venues.map((venue) => (
                                        <option key={venue.id} value={venue.id}>
                                            {venue.name}
                                        </option>
                                    ))}
                                </select>
                                {newEvent.touched.venueId && newEvent.errors.venueId && <div className="text-red-500">{newEvent.errors.venueId}</div>}
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-2">
                                    Organization <span className="text-red-500">*</span>
                                </label>
                                <select
                                    name="orgId"
                                    value={orgId || newEvent.values.orgId}
                                    onChange={(e) => {
                                        if (!orgId) {
                                            const selectedOrgId = e.target.value;
                                            const selectedOrg = organizations.find((org) => org.id === selectedOrgId);
                                            newEvent.setFieldValue('orgId', selectedOrgId);
                                        }
                                    }}
                                    disabled={!!orgId || id || evId}
                                    onBlur={newEvent.handleBlur}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                >
                                    <option value="" disabled>
                                        Select Organization
                                    </option>
                                    {organizations.map((organization) => (
                                        <option key={organization.id} value={organization.id}>
                                            {organization.name}
                                        </option>
                                    ))}
                                </select>
                                {newEvent.touched.orgId && newEvent.errors.orgId && <div className="text-red-500">{newEvent.errors.orgId}</div>}
                            </div>
                            {/* date options */}
                            <div className="flex flex-col gap-4">
                                {newEvent.values.eventDateTimes?.map((field, index) => (
                                    <div key={index} className="flex items-start gap-12">
                                        <div>
                                            <label className="block text-sm mb-2">
                                                Date <span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                                <Datetime
                                                    value={field.date}
                                                    onChange={(value) => handleDateTimeChange(index, 'date', value)}
                                                    onBlur={newEvent.handleBlur}
                                                    inputProps={{
                                                        className: "pl-8 pr-4 px-4 py-2 border rounded-md w-[140px] focus:outline-none focus:ring-1 focus:ring-blue-300",
                                                        placeholder: "DD/MM/YY"
                                                    }}
                                                    timeFormat={false}
                                                    dateFormat="DD/MM/YY"
                                                    isValidDate={(currentDate) => {
                                                        const today = new Date();

                                                        if (index === 0) {
                                                            return currentDate.isSameOrAfter(today, 'day');
                                                        } else {
                                                            const prevDate = newEvent.values.eventDateTimes[index - 1]?.date;
                                                            return prevDate ? currentDate.isAfter(prevDate) : false;
                                                        }
                                                    }}
                                                    closeOnSelect={true}
                                                />
                                                <Icon icon="cil:calendar" className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                                            </div>
                                            {newEvent.errors?.eventDateTimes?.[index]?.date && (
                                                <div className="text-red-500 text-sm mt-1">
                                                    {newEvent.errors.eventDateTimes[index].date}
                                                </div>
                                            )}
                                        </div>
                                        <div>
                                            <label className="block text-sm mb-2">
                                                Start Time <span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                                <Datetime
                                                    value={field.startTime}
                                                    onChange={(date) => handleDateTimeChange(index, "startTime", date)}
                                                    inputProps={{
                                                        className: "pl-8 pr-4 px-4 py-2 border rounded-md w-[140px] focus:outline-none focus:ring-1 focus:ring-blue-300",
                                                        placeholder: "12:00 AM"
                                                    }}
                                                    onBlur={newEvent.handleBlur}
                                                    dateFormat={false}
                                                    timeFormat="hh:mm A"
                                                />
                                                <Icon icon="bitcoin-icons:clock-outline" className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                                            </div>
                                            {newEvent.errors?.eventDateTimes?.[index]?.startTime && (
                                                <div className="text-red-500 text-sm mt-1">
                                                    {newEvent.errors.eventDateTimes[index].startTime}
                                                </div>
                                            )}
                                        </div>
                                        <div>
                                            <label className="block text-sm mb-2">
                                                End Time <span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                                <Datetime
                                                    value={field.endTime}
                                                    onChange={(date) => handleDateTimeChange(index, "endTime", date)}
                                                    inputProps={{
                                                        className: "pl-8 pr-4 px-4 py-2 border rounded-md w-[140px] focus:outline-none focus:ring-1 focus:ring-blue-300",
                                                        placeholder: "12:00 AM"
                                                    }}
                                                    onBlur={newEvent.handleBlur}
                                                    dateFormat={false}
                                                    timeFormat="hh:mm A"
                                                    isValidDate={(currentTime) => {
                                                        const startTime = newEvent.values.eventDateTimes[index]?.startTime;
                                                        return startTime ? currentTime.isAfter(startTime) : true;
                                                    }}
                                                />
                                                <Icon icon="bitcoin-icons:clock-outline" className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                                            </div>
                                            {newEvent.errors?.eventDateTimes?.[index]?.endTime && (
                                                <div className="text-red-500 text-sm mt-1">
                                                    {newEvent.errors.eventDateTimes[index].endTime}
                                                </div>
                                            )}
                                        </div>
                                        {index === newEvent.values.eventDateTimes?.length - 1 && (
                                            <button onClick={handleAddDateAndTimeField} className="p-2 border rounded-md hover:bg-gray-50">
                                                <Icon icon="material-symbols-light:add" className="w-5 h-5 text-gray-600" />
                                            </button>
                                        )}
                                        {newEvent.values.eventDateTimes?.length > 1 && (
                                            <button onClick={() => handleDeleteDateAndTimeField(index)} className="p-2 border rounded-md hover:bg-gray-50">
                                                <Icon icon="material-symbols-light:remove" className="w-5 h-5 text-red-600" />
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <div>
                                        <label className="block text-sm font-medium mb-2">Registration Opening Date <span className="text-red-500">*</span></label>
                                        <div className="relative">
                                            <Datetime
                                                value={newEvent.values.registrationOpenDate}
                                                onChange={(date) => newEvent.setFieldValue("registrationOpenDate", date)}
                                                onBlur={() => newEvent.setFieldTouched("registrationOpenDate", true)}
                                                inputProps={{ placeholder: "Opening Date", required: true }}
                                                isValidDate={(currentDate) => {
                                                    const firstDateTime = newEvent.values.eventDateTimes[0]?.date;
                                                    const today = new Date;
                                                    if (!evId) {
                                                        // If ID is not available, check both conditions: >= today and < firstDateTime
                                                        return currentDate.isSameOrAfter(today, "day") && currentDate.isBefore(firstDateTime);
                                                    }
                                                    return currentDate.isBefore(firstDateTime); // Ensuring selected date is before firstDateTimeStart
                                                }}
                                                dateFormat="DD/MM/YYYY"
                                                className="mb-4 px-4 py-2 border rounded-md"
                                            />
                                            {newEvent.touched.registrationOpenDate && newEvent.errors.registrationOpenDate && (
                                                <div className="text-red-500">{newEvent.errors.registrationOpenDate}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {/* second column */}
                                <div>
                                    <div>
                                        <label className="block text-sm font-medium mb-2">Registration Closing Date <span className="text-red-500">*</span></label>
                                        <div className="relative">
                                            <Datetime
                                                value={newEvent.values.registrationCloseDate}
                                                onChange={(date) => newEvent.setFieldValue("registrationCloseDate", date)}
                                                onBlur={() => newEvent.setFieldTouched("registrationCloseDate", true)}
                                                inputProps={{ placeholder: "Closing Date", required: true }}
                                                isValidDate={(currentDate) => {
                                                    const registrationOpenDate = newEvent.values.registrationOpenDate;
                                                    const firstStartDate = newEvent.values.eventDateTimes[0].date;
                                                    const isBeforeOrSameAsStartDate = currentDate.isSameOrBefore(firstStartDate);
                                                    const isAfterOrSameAsOpen = currentDate.isAfter(registrationOpenDate);

                                                    return isBeforeOrSameAsStartDate && isAfterOrSameAsOpen;
                                                }}
                                                dateFormat="DD/MM/YY"
                                                className="mb-4 px-4 py-2 border rounded-md"
                                            // timeFormat={false}
                                            />
                                            {newEvent.touched.registrationCloseDate && newEvent.errors.registrationCloseDate && (
                                                <div className="text-red-500">{newEvent.errors.registrationCloseDate}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-2">
                                    Trailer link
                                </label>
                                <input
                                    type="text"
                                    name="trailer"
                                    value={newEvent.values.trailer}
                                    onChange={newEvent.handleChange}
                                    onBlur={newEvent.handleBlur}
                                    placeholder="e.g. https://www.youtube.com/embed/your-video-id"
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                />
                                {newEvent.touched.trailer && newEvent.errors.trailer && <div className="text-red-500">{newEvent.errors.trailer}</div>}
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-2">
                                    Tags<span className="ml-1 text-xs text-grey-100">(seperate with comma)</span>
                                </label>
                                <input
                                    type="text"
                                    name="tags"
                                    value={newEvent.values.tags}
                                    onChange={newEvent.handleChange}
                                    placeholder="e.g. music, concert, live"
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-2">
                                    Event Description <span className="text-red-500">*</span>
                                </label>
                                <ReactQuill
                                    theme='snow'
                                    value={newEvent.values.description}
                                    onChange={(value) => newEvent.setFieldValue('description', value)}
                                    onBlur={() => newEvent.setFieldTouched('description', true)}
                                    styles={{
                                        border: 'none'
                                    }}
                                    className="border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300 [&>.ql-container]:border-none [&>.ql-toolbar]:border-none"
                                />
                                {(newEvent.touched.description && newEvent.errors.description) && <div className="text-red-500">{newEvent.errors.description}</div>}
                            </div>
                            <div>
                                <div className="flex items-center gap-3 mt-1 mb-2">
                                    <span className=" text-sm font-medium mb-2 mr-1">Add As Sub Event</span>
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input
                                            type="checkbox"
                                            className="sr-only peer"
                                            checked={isSubEvent}
                                            onChange={() => {
                                                setIsSubEvent(!isSubEvent);
                                            }}
                                            aria-label="Toggle sub event"
                                        />
                                        <div className="w-14 h-7 bg-gray-300 peer-focus:ring-2 peer-focus:ring-blue-400 rounded-full relative transition-all peer-checked:bg-blue-600">
                                            <div className={`absolute top-1 left-1 w-5 h-5 bg-white border border-gray-300 rounded-full shadow-md transition-all transform   ${isSubEvent ? "translate-x-7 border-white" : ""}`} />
                                        </div>
                                    </label>
                                </div>
                            </div>
                            {isSubEvent && (
                                <div>
                                    <div>
                                        <label className="block text-sm font-medium mb-2">
                                            Main Event <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            name="mainEventId"
                                            value={newEvent.values.mainEventId}
                                            onChange={newEvent.handleChange}
                                            onBlur={newEvent.handleBlur}
                                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                        >
                                            <option value="" disabled>
                                                Select Main Event
                                            </option>
                                            {mainEvents.map((mainEvent) => (
                                                <option key={mainEvent.id} value={mainEvent.id}>
                                                    {mainEvent.name}
                                                </option>
                                            ))}
                                        </select>
                                        {newEvent.touched.mainEventId && newEvent.errors.mainEventId && <div className="text-red-500">{newEvent.errors.mainEventId}</div>}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="max-w-3xl mx-auto space-y-8">
                        <h2 className="text-2xl font-semibold text-gray-800 mb-6">Event Images</h2>

                        {/* Cover Image */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                <h3 className="text-lg font-medium text-gray-800">Cover Image</h3>
                            </div>
                            <div className="space-y-4">
                                <input
                                    type="file"
                                    accept="image/*"
                                    name="coverImage"
                                    onChange={handleCoverImageChange}
                                    onBlur={() => newEvent.setFieldTouched("coverImage", true)}
                                    className="hidden"
                                    id="coverImageInput"
                                />
                                {!coverImagePreview ? (
                                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-gray-400 transition-colors">
                                        <div className="space-y-4">
                                            <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <div>
                                                <label htmlFor="coverImageInput" className="cursor-pointer">
                                                    <span className="inline-flex items-center px-2 py-1 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors">
                                                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                                        </svg>
                                                        Upload Cover Image
                                                    </span>
                                                </label>
                                            </div>
                                            {/* <p className="text-sm text-gray-500">Drag and drop or click to select</p> */}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="relative inline-block">
                                        <div className="relative w-full h-24 rounded-lg overflow-hidden shadow-md">
                                            <img
                                                src={coverImagePreview}
                                                className="w-full h-full object-cover"
                                                alt="Cover preview"
                                            />
                                            <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-20 transition-all duration-200 flex items-center justify-center">
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveImage("coverImage")}
                                                    className="opacity-0 hover:opacity-100 transition-opacity bg-red-500 hover:bg-red-600 text-white p-2 rounded-full shadow-lg"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="mt-3 flex gap-2">
                                            <label htmlFor="coverImageInput" className="cursor-pointer">
                                                <span className="inline-flex items-center px-2 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors">
                                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                                    </svg>
                                                    Change Image
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                )}

                                {newEvent.touched.coverImage && newEvent.errors.coverImage && (
                                    <div className="flex items-center gap-2 text-red-600 text-sm">
                                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                        </svg>
                                        {newEvent.errors.coverImage}
                                    </div>
                                )}
                                <p className="text-xs text-gray-500 flex items-center gap-2">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Recommended: below 1MB, 1:1 aspect ratio, JPG/JPEG/PNG format
                                </p>
                            </div>
                        </div>

                        {/* Other Images */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <h3 className="text-lg font-medium text-gray-800">Gallery Images</h3>
                            </div>
                            <div className="space-y-4">
                                <input
                                    type="file"
                                    multiple
                                    accept="image/*"
                                    name="images"
                                    onChange={handleOtherImagesChange}
                                    onBlur={() => newEvent.setFieldTouched("images", true)}
                                    className="hidden"
                                    id="galleryImagesInput"
                                />
                                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-gray-400 transition-colors">
                                    <div className="space-y-3">
                                        <svg className="mx-auto h-10 w-10 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                                            <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <div>
                                            <label htmlFor="galleryImagesInput" className="cursor-pointer">
                                                <span className="inline-flex items-center px-2 py-1 border border-transparent text-base font-medium rounded-md text-white bg-green-600 hover:bg-green-700 transition-colors">
                                                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                                    </svg>
                                                    Upload Images
                                                </span>
                                            </label>
                                        </div>
                                        <p className="text-sm text-gray-500">Select multiple images for your event gallery</p>
                                    </div>
                                </div>

                                {imagePreviews.length > 0 && (
                                    <div className="mt-4">
                                        <h4 className="text-sm font-medium text-gray-700 mb-3">Selected Images ({imagePreviews.length})</h4>
                                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
                                            {imagePreviews.map((img, idx) => (
                                                <div key={idx} className="relative group">
                                                    <div className="relative w-24 h-24 rounded-lg overflow-hidden shadow-sm">
                                                        <img
                                                            src={img.url}
                                                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                                                            alt={`Gallery image ${idx + 1}`}
                                                        />
                                                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-200 flex items-center justify-center">
                                                            <button
                                                                type="button"
                                                                onClick={() => handleRemoveImage("images", idx)}
                                                                className="opacity-0 group-hover:opacity-100 transition-opacity bg-red-500 hover:bg-red-600 text-white p-1.5 rounded-full shadow-lg"
                                                            >
                                                                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="mt-3">
                                            <label htmlFor="galleryImagesInput" className="cursor-pointer">
                                                <span className="inline-flex items-center px-2 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors">
                                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                    </svg>
                                                    Add More Images
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                )}

                                {newEvent.touched.images && newEvent.errors.images && (
                                    <div className="flex items-center gap-2 text-red-600 text-sm">
                                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                        </svg>
                                        {newEvent.errors.images}
                                    </div>
                                )}
                                <p className="text-xs text-gray-500 flex items-center gap-2">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Recommended: below 1MB each, JPG/JPEG/PNG format
                                </p>
                            </div>
                        </div>

                        {/* Feature Image */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                                <h3 className="text-lg font-medium text-gray-800">Feature Image</h3>
                            </div>

                            <div className="space-y-4">
                                <input
                                    type="file"
                                    accept="image/*"
                                    name="featureImage"
                                    onChange={handleFeatureImageChange}
                                    onBlur={() => newEvent.setFieldTouched("featureImage", true)}
                                    className="hidden"
                                    id="featureImageInput"
                                />

                                {!featureImagePreview ? (
                                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-gray-400 transition-colors">
                                        <div className="space-y-4">
                                            <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <div>
                                                <label htmlFor="featureImageInput" className="cursor-pointer">
                                                    <span className="inline-flex items-center px-2 py-1 border border-transparent text-base font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 transition-colors">
                                                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                                        </svg>
                                                        Upload Feature Image
                                                    </span>
                                                </label>
                                            </div>
                                            {/* <p className="text-sm text-gray-500">Drag and drop or click to select</p> */}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="relative inline-block">
                                        <div className="relative w-full h-24 rounded-lg overflow-hidden shadow-md">
                                            <img
                                                src={featureImagePreview}
                                                className="w-full h-full object-cover"
                                                alt="Feature preview"
                                            />
                                            <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-20 transition-all duration-200 flex items-center justify-center">
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveImage("featureImage")}
                                                    className="opacity-0 hover:opacity-100 transition-opacity bg-red-500 hover:bg-red-600 text-white p-2 rounded-full shadow-lg"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="mt-3 flex gap-2">
                                            <label htmlFor="featureImageInput" className="cursor-pointer">
                                                <span className="inline-flex items-center px-2 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors">
                                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                                    </svg>
                                                    Change Image
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                )}

                                {newEvent.touched.featureImage && newEvent.errors.featureImage && (
                                    <div className="flex items-center gap-2 text-red-600 text-sm">
                                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                        </svg>
                                        {newEvent.errors.featureImage}
                                    </div>
                                )}
                                <p className="text-xs text-gray-500 flex items-center gap-2">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Recommended: below 1MB, JPG/JPEG/PNG format
                                </p>
                            </div>
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div className="max-w-3xl mx-auto px-4 py-8 rounded-xl">
                        <>
                            <h2 className="text-lg font-medium mb-8">Tickets & Event Zone Details</h2>

                            {/* Event Type Selection */}
                            <div className="grid md:grid-cols-2 gap-6 mb-6">
                                {/* Ticketed Event Card */}
                                <div
                                    className={`border-2 rounded-xl p-6 transition-all duration-200 cursor-pointer shadow-sm hover:shadow-md ${newEvent.values.ticketType === "Ticketed Event" ? "border-blue-300 bg-blue-50" : "border-gray-200 hover:border-blue-300"}`}
                                    onClick={() => {
                                        newEvent.setFieldValue("ticketType", "Ticketed Event");
                                        newEvent.setFieldValue("isFree", false);
                                        setIsFreeEvent(false);
                                    }}
                                >
                                    <div className="flex items-center justify-center mb-4">
                                        <Icon icon="ion:ticket-outline" className="text-5xl text-blue-500" />
                                    </div>
                                    <h3 className="text-center font-medium mb-2">Ticketed Event</h3>
                                    <p className="text-sm text-center text-gray-600">My event requires tickets for entry</p>
                                </div>

                                {/* Free Event Card */}
                                <div
                                    className={`border-2 rounded-xl p-6 transition-all duration-200 cursor-pointer shadow-sm hover:shadow-md ${newEvent.values.ticketType === "Free Event" ? "border-blue-300 bg-blue-50" : "border-gray-200 hover:border-blue-300"}`}
                                    onClick={() => {
                                        newEvent.setFieldValue("ticketType", "Free Event");
                                        newEvent.setFieldValue("isFree", true);
                                        setIsFreeEvent(true);
                                    }}
                                >
                                    <div className="flex items-center justify-center mb-4">
                                        <Icon icon="arcticons:free-basics" className="text-5xl text-green-500" />
                                    </div>
                                    <h3 className="text-center font-medium mb-2">Free Event</h3>
                                    <p className="text-sm text-center text-gray-600">Im running a free event</p>
                                </div>
                            </div>

                            {/* Ticket Booking Options */}
                            <div className="bg-white p-6 rounded-xl shadow-md mb-6">
                                <h2 className="font-medium mb-6 border-b pb-3">Ticket Booking Options</h2>
                                <div className="space-y-6">
                                    <div className="flex flex-wrap gap-6">
                                        {[{ label: "Single Ticket", value: "true" }, { label: "Multiple Ticket", value: "false" }].map((option) => (
                                            <label key={option.value} className="flex items-center space-x-3 text-gray-700">
                                                <input
                                                    type="radio"
                                                    name="isSingleRegistrationPerTicket"
                                                    value={option.value}
                                                    onChange={newEvent.handleChange}
                                                    checked={String(newEvent.values.isSingleRegistrationPerTicket) === String(option.value)}
                                                    // checked={newEvent.values.isSingleRegistrationPerTicket === option.value}
                                                    className="form-radio h-5 w-5 text-blue-600"
                                                />
                                                <span>{option.label}</span>
                                            </label>
                                        ))}
                                    </div>
                                    {(newEvent.values.isSingleRegistrationPerTicket === "false" || !newEvent.values.isSingleRegistrationPerTicket) && (
                                        <div className="flex flex-col md:flex-row md:items-center gap-3">
                                            <label className="block">Ticket Purchase Limit</label>
                                            <input
                                                type="number"
                                                name="ticketPurchaseLimit"
                                                value={newEvent.values.ticketPurchaseLimit}
                                                onChange={newEvent.handleChange}
                                                placeholder="maximum tickets per registration"
                                                className="px-4 py-2 w-full md:w-32 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                                min="1"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Event Zone Section */}
                            <div className="bg-white p-6 rounded-xl shadow-md mb-6">
                                <div className="flex justify-between items-center mb-4">
                                    <h2 className="font-medium">Event Zone</h2>
                                </div>

                                {/* Zone Selection - Grid Layout */}
                                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mt-2">
                                    {[...eventZones.map(z => ({ ...z, source: 'event' })), ...fetchedVenueZones.map(z => ({ ...z, source: 'fetched' }))].map((zone) => (
                                        <label key={`${zone.source}-${zone.id}`} className="flex items-center space-x-2 p-2 border rounded-md hover:bg-gray-50 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="venueZone"
                                                value={zone.id}
                                                onChange={() => {
                                                    setSelectedVenueZone(zone);
                                                    newEvent.setValues({
                                                        ...newEvent.values,
                                                        zoneName: zone.name || "",
                                                        capacity: zone.capacity || "",
                                                        isSeat: zone.isSeat ? "true" : "false",
                                                        totalRows: zone.isSeat ? zone.totalRows || "" : "",
                                                        totalSeatsPerRows: zone.isSeat ? zone.totalSeatsPerRows || "" : ""
                                                    });
                                                }}
                                                checked={selectedVenueZone?.id === zone.id}
                                                className="form-radio h-4 w-4 text-blue-600 flex-shrink-0"
                                            />
                                            <span className="text-sm truncate">{zone.name}</span>
                                        </label>
                                    ))}

                                    {/* Custom Zone Option */}
                                    <label className="flex items-center space-x-2 p-2 border rounded-md hover:bg-gray-50 cursor-pointer text-gray-700">
                                        <input
                                            type="radio"
                                            name="venueZone"
                                            value=""
                                            onChange={() => {
                                                setSelectedVenueZone(null);
                                                newEvent.setValues({
                                                    ...newEvent.values,
                                                    zoneName: "",
                                                    capacity: "",
                                                    isSeat: "false",
                                                    totalRows: "",
                                                    totalSeatsPerRows: "",
                                                });
                                            }}
                                            checked={selectedVenueZone === null}
                                            className="form-radio h-4 w-4 text-blue-600 flex-shrink-0"
                                        />
                                        <span className="text-sm">Custom</span>
                                    </label>
                                </div>

                                <div className="mt-6 space-y-5 border-t pt-5">
                                    <div className="space-y-2">
                                        <label className="block font-medium">Zone Name</label>
                                        <input
                                            type="text"
                                            name="zoneName"
                                            value={newEvent.values.zoneName}
                                            onChange={newEvent.handleChange}
                                            onBlur={newEvent.handleBlur}
                                            placeholder="e.g. Main Hall, VIP Section"
                                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                        />
                                        {newEvent.touched.zoneName && newEvent.errors.zoneName &&
                                            <div className="text-red-500 text-sm">{newEvent.errors.zoneName}</div>
                                        }
                                    </div>

                                    <div className="space-y-2">
                                        <label className="block font-medium">Capacity</label>
                                        <input
                                            type="number"
                                            name="capacity"
                                            value={newEvent.values.capacity}
                                            onChange={newEvent.handleChange}
                                            onBlur={newEvent.handleBlur}
                                            // disabled={selectedVenueZone !== null}
                                            placeholder="Maximum number of attendees"
                                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300 disabled:bg-gray-100"
                                            min={1}
                                        />
                                        {newEvent.touched.capacity && newEvent.errors.capacity &&
                                            <div className="text-red-500 text-sm">{newEvent.errors.capacity}</div>
                                        }
                                    </div>

                                    {/* Seat Setup Section */}
                                    {selectedVenueZone === null && (
                                        <div className="space-y-3">
                                            <div className="flex items-center gap-4 h-8">
                                                <p className="font-medium">Seat Setup</p>
                                                <div className="flex gap-4">
                                                    {[{ label: "Yes", value: "true" }, { label: "No", value: "false" }].map((option) => (
                                                        <label key={option.value} className="flex items-center space-x-2 text-gray-700">
                                                            <input
                                                                type="radio"
                                                                name="isSeat"
                                                                value={option.value}
                                                                onChange={(e) => {
                                                                    newEvent.setFieldValue("isSeat", e.target.value);
                                                                    if (e.target.value === "false") {
                                                                        newEvent.setFieldValue("totalRows", "");
                                                                        newEvent.setFieldValue("totalSeatsPerRows", "");
                                                                    }
                                                                }}
                                                                checked={String(newEvent.values.isSeat) === option.value}
                                                                className="form-radio h-4 w-4 text-blue-600"
                                                            />
                                                            <span className="text-sm">{option.label}</span>
                                                        </label>
                                                    ))}
                                                </div>

                                                {/* Create Seat Layout Button - Same Row */}
                                                {newEvent.values.isSeat === "true" && (
                                                    <button
                                                        type='button'
                                                        onClick={openSeatSetupModel}
                                                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition text-sm"
                                                    >
                                                        Create Seat Layout
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {/* View Seat Layout for Selected Venue Zone */}
                                    {selectedVenueZone && (
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center gap-4">
                                                {selectedVenueZone?.seats?.length > 0 ? (
                                                    <button
                                                        type='button'
                                                        onClick={openSeatViewModel}
                                                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition text-sm"
                                                    >
                                                        View Seat Layout
                                                    </button>
                                                ) : (
                                                    <span className="text-sm text-gray-500">No seats available for this zone</span>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {/* Save Button - Right Aligned */}
                                    {(selectedVenueZone?.source === 'fetched' || selectedVenueZone === null) && (
                                        <div className="flex justify-end pt-4 border-t">
                                            <button
                                                type="button"
                                                onClick={() => saveZone(newEvent.values)}
                                                className="bg-green-500 text-white px-4 py-1 rounded-lg hover:bg-green-600 transition"
                                            >
                                                Save Zone
                                            </button>
                                        </div>
                                    )}
                                    {/* Update Button - Right Aligned */}
                                    {(selectedVenueZone && selectedVenueZone?.source === 'event') && (
                                        <div className="flex justify-end pt-4 border-t">
                                            <button
                                                type="button"
                                                onClick={() => updateZone(newEvent.values)}
                                                className="bg-amber-500 text-white px-4 py-1 rounded-lg hover:bg-amber-600 transition"
                                            >
                                                Update Zone
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* ticket category */}

                            <div
                                className={`bg-white p-6 rounded-xl shadow-md mb-6 ${!(selectedVenueZone && selectedVenueZone.source === 'event') ? 'opacity-50 pointer-events-none' : ''
                                    }`}
                            >
                                <h2 className="font-medium mb-6 text-gray-800 border-b pb-3">Ticket Details</h2>

                                {selectedVenueZone && tickets
                                    .map((ticket, i) => ({ ticket, index: i }))
                                    .filter(({ ticket }) => ticket.zoneId === selectedVenueZone?.id)
                                    .map(({ ticket, index }) => (
                                        <div key={index} className="grid md:grid-cols-2 gap-6 mb-4 p-4 border rounded-lg bg-gray-50">
                                            <div className="space-y-2">
                                                <label className="block">Ticket Name</label>
                                                <input
                                                    type="text"
                                                    name={`tickets[${index}].name`}
                                                    value={ticket.name}
                                                    onChange={(e) => updateTicket(index, "name", e.target.value)}
                                                    onBlur={newEvent.handleBlur}
                                                    placeholder="e.g. General Admission"
                                                    required
                                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300" />
                                                {newEvent.touched.tickets?.[index]?.name && newEvent.errors.tickets?.[index]?.name && (
                                                    <div className="text-red-500 text-sm">{newEvent.errors.tickets[index].name}</div>
                                                )}
                                            </div>
                                            {!isFreeEvent && (
                                                <>
                                                    <div className="space-y-2">
                                                        <label className="block">Price</label>
                                                        <input
                                                            type="number"
                                                            name={`tickets[${index}].price`}
                                                            value={ticket.price}
                                                            onChange={(e) => updateTicket(index, "price", e.target.value)}
                                                            onBlur={newEvent.handleBlur}
                                                            placeholder="100"
                                                            min={1}
                                                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                                        />
                                                        {newEvent.touched.tickets?.[index]?.price && newEvent.errors.tickets?.[index]?.price && (
                                                            <div className="text-red-500 text-sm">{newEvent.errors.tickets[index].price}</div>
                                                        )}
                                                    </div>
                                                    <div className="space-y-2">
                                                        <label className="block">Discount</label>
                                                        <input
                                                            type="number"
                                                            name={`tickets[${index}].discount`}
                                                            value={ticket.discount}
                                                            onChange={(e) => updateTicket(index, "discount", e.target.value)}
                                                            placeholder="0"
                                                            min={0}
                                                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                                        />
                                                        {newEvent.touched.tickets?.[index]?.discount && newEvent.errors.tickets?.[index]?.discount && (
                                                            <div className="text-red-500 text-sm">{newEvent.errors.tickets[index].discount}</div>
                                                        )}
                                                    </div>
                                                    <div className="space-y-2">
                                                        <label className="block mb-4">Ticket Category</label>
                                                        <div className="flex gap-6">
                                                            <label className="flex items-center space-x-3 text-gray-700">
                                                                <input
                                                                    type="radio"
                                                                    name={`tickets[${index}].type`}
                                                                    value="regular"
                                                                    onChange={() => updateTicket(index, "type", "regular")}
                                                                    checked={ticket.type === "regular"}
                                                                    className="form-radio h-5 w-5 text-blue-600"
                                                                />
                                                                <span>Regular</span>
                                                            </label>
                                                            <label className="flex items-center space-x-3">
                                                                <input
                                                                    type="radio"
                                                                    name={`tickets[${index}].type`}
                                                                    value="earlybird"
                                                                    onChange={() => updateTicket(index, "type", "earlybird")}
                                                                    checked={ticket.type === "earlybird"}
                                                                    className="form-radio h-5 w-5 text-blue-600"
                                                                />
                                                                <span>Early Bird</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {newEvent.values.tickets?.[index]?.type === "earlybird" && (
                                                        <div>
                                                            <div className="space-y-2">
                                                                <label className="block">Early Bird Price</label>
                                                                <input
                                                                    type="number"
                                                                    name={`tickets[${index}].earlybirdPrice`}
                                                                    value={ticket.earlybirdPrice}
                                                                    onChange={(e) => updateTicket(index, "earlybirdPrice", e.target.value)}
                                                                    onBlur={newEvent.handleBlur}
                                                                    placeholder="100"
                                                                    min={1}
                                                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                                                />
                                                                {newEvent.touched.tickets?.[index]?.earlybirdPrice && newEvent.errors.tickets?.[index]?.earlybirdPrice && (
                                                                    <div className="text-red-500 text-sm">{newEvent.errors.tickets[index].earlybirdPrice}</div>
                                                                )}
                                                            </div>
                                                            <div className="space-y-2">
                                                                <label className="block">Early Bird Total Count</label>
                                                                <input
                                                                    type="number"
                                                                    name={`tickets[${index}].earlybirdTotalCount`}
                                                                    value={ticket.earlybirdTotalCount}
                                                                    onChange={(e) => updateTicket(index, "earlybirdTotalCount", e.target.value)}
                                                                    onBlur={newEvent.handleBlur}
                                                                    placeholder="Number of tickets available as early bird"
                                                                    min={1}
                                                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                                                />
                                                                {newEvent.touched.tickets?.[index]?.earlybirdTotalCount && newEvent.errors.tickets?.[index]?.earlybirdTotalCount && (
                                                                    <div className="text-red-500 text-sm">{newEvent.errors.tickets[index].earlybirdTotalCount}</div>
                                                                )}
                                                            </div>
                                                            <div className="space-y-2">
                                                                <label className="block">Early Bird Closing Date</label>
                                                                <Datetime
                                                                    value={ticket.earlybirdCloseDate}
                                                                    onChange={(date) => updateTicket(index, "earlybirdCloseDate", date)}
                                                                    onBlur={newEvent.handleBlur}
                                                                    inputProps={{
                                                                        placeholder: "Select end date for early bird",
                                                                        className: "w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300",
                                                                    }}
                                                                    isValidDate={(currentDate) => {
                                                                        const isAfterOpenDate = currentDate.isAfter(newEvent.values.registrationOpenDate);
                                                                        const isBeforeCloseDate = currentDate.isSameOrBefore(newEvent.values.registrationCloseDate);
                                                                        return isAfterOpenDate && isBeforeCloseDate;
                                                                    }}
                                                                    timeFormat={false}
                                                                    dateFormat="DD/MM/YYYY"
                                                                />
                                                                {newEvent.touched.tickets?.[index]?.earlybirdCloseDate && newEvent.errors.tickets?.[index]?.earlybirdCloseDate && (
                                                                    <div className="text-red-500 text-sm">{newEvent.errors.tickets[index].earlybirdCloseDate}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                            <div className="space-y-2">
                                                <label className="block">Total Count</label>
                                                <input
                                                    type="number"
                                                    name={`tickets[${index}].totalCount`}
                                                    value={ticket.totalCount}
                                                    onChange={(e) => updateTicket(index, "totalCount", e.target.value)}
                                                    onBlur={newEvent.handleBlur}
                                                    placeholder="Number of tickets available"
                                                    min={1}
                                                    required
                                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                                />
                                                {newEvent.touched.tickets?.[index]?.totalCount && newEvent.errors.tickets?.[index]?.totalCount && (
                                                    <div className="text-red-500 text-sm">{newEvent.errors.tickets[index].totalCount}</div>
                                                )}
                                            </div>
                                            <div className="space-y-2">
                                                <label className="block">Closing Date</label>
                                                <Datetime
                                                    value={ticket.closeDate}
                                                    onChange={(date) => updateTicket(index, "closeDate", date)}
                                                    onBlur={newEvent.handleBlur}
                                                    inputProps={{
                                                        placeholder: "Select end date",
                                                        className: "w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300",
                                                    }}
                                                    isValidDate={(currentDate) => {
                                                        const isAfterOpenDate = currentDate.isAfter(newEvent.values.registrationOpenDate);
                                                        const isBeforeCloseDate = currentDate.isSameOrBefore(newEvent.values.registrationCloseDate);
                                                        return isAfterOpenDate && isBeforeCloseDate;
                                                    }}
                                                    timeFormat={false}
                                                    dateFormat="DD/MM/YYYY"
                                                />
                                                {newEvent.touched.tickets?.[index]?.closeDate && newEvent.errors.tickets?.[index]?.closeDate && (
                                                    <div className="text-red-500 text-sm">{newEvent.errors.tickets[index].closeDate}</div>
                                                )}
                                            </div>

                                            {/* <div className="space-y-2">
                                                    <label className="block">Points</label>
                                                    <input
                                                        type="number"
                                                        name={`tickets[${index}].points`}
                                                        value={ticket.points}
                                                        onChange={(e) => updateTicket(index, "points", e.target.value)}
                                                        placeholder="0"
                                                        min={0}
                                                        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-300"
                                                    />
                                                    {newEvent.touched.tickets?.[index]?.points && newEvent.errors.tickets?.[index]?.points && (
                                                        <div className="text-red-500 text-sm">{newEvent.errors.tickets[index].points}</div>
                                                    )}
                                                </div> */}

                                            <div>
                                                <label className="block mb-4">Ticket Category Image</label>
                                                <div className="flex items-center gap-4">
                                                    {newEvent.values.tickets?.[index]?.ticketCategoryImage ? (
                                                        <>
                                                            <div className="flex items-center gap-4">
                                                                <img
                                                                    src={
                                                                        newEvent.values.tickets[index].ticketCategoryImage instanceof File
                                                                            ? URL.createObjectURL(newEvent.values.tickets[index].ticketCategoryImage)
                                                                            : newEvent.values.tickets[index].ticketCategoryImageUrl || ''
                                                                    }
                                                                    alt="Ticket Category Image Preview"
                                                                    className="w-20 h-20 object-cover rounded border"
                                                                />
                                                                <div className="flex flex-col gap-2">
                                                                    <label htmlFor={`ticketCategoryImageInput-${index}`} className="cursor-pointer">
                                                                        <span className="px-6 py-1 bg-blue-500 text-white rounded hover:bg-blue-600">
                                                                            Change
                                                                        </span>
                                                                    </label>
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            const imageFile = newEvent.values.tickets?.[index]?.ticketCategoryImage;
                                                                            if (imageFile) {
                                                                                addTicketCategoryImage(imageFile, index);
                                                                            } else {
                                                                                toast.error("Please select an image before saving.");
                                                                            }
                                                                        }}
                                                                        disabled={ticketCatImageLoading}
                                                                        className="px-6 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                                                                    >
                                                                        {ticketCatImageLoading ? "Saving..." : "Save"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className="flex items-center gap-2">
                                                            <label htmlFor={`ticketCategoryImageInput-${index}`} className="cursor-pointer">
                                                                <span className="inline-flex items-center px-2 py-1 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors">
                                                                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                                                    </svg>
                                                                    Upload
                                                                </span>
                                                            </label>
                                                        </div>
                                                    )}

                                                    {/* Hidden input for file selection */}
                                                    <input
                                                        type="file"
                                                        name={`tickets[${index}].ticketCategoryImage`}
                                                        onChange={(e) => updateTicket(index, 'ticketCategoryImage', e.currentTarget.files[0])}
                                                        onBlur={() => newEvent.setFieldTouched(`tickets[${index}].ticketCategoryImage`, true)}
                                                        className="hidden"
                                                        accept="image/*"
                                                        id={`ticketCategoryImageInput-${index}`}
                                                    />
                                                </div>

                                                <div className="text-amber-400 text-sm mt-2">Save image before updating the event</div>

                                                {newEvent.touched.tickets?.[index]?.ticketCategoryImage &&
                                                    newEvent.errors.tickets?.[index]?.ticketCategoryImage && (
                                                        <div className="text-red-500 text-sm">{newEvent.errors.tickets[index].ticketCategoryImage}</div>
                                                    )}
                                            </div>

                                            <div className="flex justify-end col-span-2 gap-2">
                                                {ticket.id && selectedVenueZone?.id && selectedVenueZone?.source === 'event' && (
                                                    <div className="flex justify-end col-span-2">
                                                        <button
                                                            type="button"
                                                            disabled={ticketCatUpdateLoadingMap[ticket.id]}
                                                            onClick={() => editTicketCategory(ticket)}
                                                            className="bg-amber-500 text-white px-4 py-1 rounded-lg hover:bg-amber-600 transition"
                                                        >
                                                            {ticketCatUpdateLoadingMap[ticket.id] ? 'Updating...' : 'Update'}
                                                        </button>
                                                    </div>
                                                )}
                                                {id && ticket.id && selectedVenueZone && selectedVenueZone.id && selectedVenueZone.source === 'event' && (
                                                    <div className="flex justify-end col-span-2">
                                                        <button
                                                            type="button"
                                                            disabled={ticketCatDeleteLoadingMap[ticket.id]}
                                                            onClick={() => deleteTicketCategory(ticket.id)}
                                                            className="bg-red-500 text-white px-4 py-1 rounded-lg hover:bg-red-600 transition"
                                                        >
                                                            {ticketCatDeleteLoadingMap[ticket.id] ? 'Deleting...' : 'Delete'}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="flex justify-end col-span-2 gap-2">
                                                {selectedVenueZone?.id && selectedVenueZone?.source === 'event' && !ticket.id && (
                                                    <button
                                                        type="button"
                                                        disabled={ticket.id || ticketCatAddLoading}
                                                        onClick={() => addTicketCategory(ticket)}
                                                        className="bg-green-500 text-white px-4 py-1 rounded-lg hover:bg-green-600 transition"
                                                    >
                                                        {ticketCatAddLoading ? 'Adding...' : 'Add'}
                                                    </button>
                                                )}
                                                {!ticket.id && (
                                                    <div className="flex justify-end col-span-2">
                                                        <button
                                                            type="button"
                                                            onClick={() => removeTicket(index)}
                                                            className="bg-red-500 text-white px-4 py-1 rounded-lg hover:bg-red-600 transition"
                                                        >
                                                            Remove
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                <div className="flex items-end justify-start mt-4">
                                    <button
                                        type="button"
                                        onClick={addTicket}
                                        className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Add Ticket Category
                                    </button>
                                </div>

                            </div>

                        </>
                    </div>
                );
            case 4:
                return (
                    <div className="max-w-4xl mx-auto bg-white shadow-sm rounded-md overflow-hidden">
                        {/* Banner Image */}
                        <div className="relative h-64 bg-black">
                            <img
                                src={newEvent.values.coverImage || "/api/placeholder/800/300"}
                                alt="Event banner"
                                className="w-full h-full object-cover opacity-80"
                            />
                        </div>

                        <h1 className="text-2xl font-bold mt-8">{newEvent.values.name || 'Title'}</h1>
                        <div className="flex flex-col md:flex-row">
                            {/* Main Content */}
                            <div className="flex-1 p-6">
                                {/* Host Info */}
                                <div className="mb-6">
                                    <h2 className="text-sm text-gray-500 mb-2">Hosted by</h2>
                                    <div className="flex items-center">
                                        <img
                                            src={organizations.find(v => v.id === newEvent.values.orgId)?.coverImage?.secure_url || "/api/placeholder/40/40"}
                                            alt="Host"
                                            className="w-10 h-10 rounded-full object-cover mr-3"
                                        />
                                        <span className="font-medium">{organizations.find(v => v.id === newEvent.values.orgId)?.name || 'Organization Name'}</span>
                                        {/* <button className="ml-auto text-xs bg-gray-800 text-white px-3 py-1 rounded">Follow</button> */}
                                    </div>
                                </div>

                                {/* Event Description */}
                                <div className="mb-6">
                                    <h2 className="font-semibold mb-2">Event Description</h2>
                                    <p className="text-sm text-gray-600">{newEvent.values.description.length > 50
                                        ? newEvent.values.description.replace(/<[^>]*>/g, '').substring(0, 50) + '...'
                                        : newEvent.values.description.replace(/<[^>]*>/g, '')}</p>
                                </div>

                                <div className="mb-6">
                                    <h2 className="font-semibold mb-2">Date & Time</h2>
                                    {newEvent.values.eventDateTimes?.map((event, index) => (
                                        <div key={index} className="flex items-center mb-2">
                                            {/* Circle Indicator */}
                                            <Icon icon="solar:calendar-broken" className="text-lg mr-1" />

                                            {/* Date & Time */}
                                            <p className="text-sm text-gray-600">
                                                {new Date(event.date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })} |
                                                {new Date(event.startTime).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })} -
                                                {new Date(event.endTime).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}
                                            </p>
                                        </div>
                                    ))}
                                </div>


                                {/* Map */}
                                {/* <div className="mt-6">
                                    <p className="text-xs text-gray-500 mb-2">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                                    <div className="h-36 bg-blue-50 rounded-md relative overflow-hidden">
                                        <img
                                            src="/api/placeholder/600/200"
                                            alt="Event location map"
                                            className="w-full h-full object-cover"
                                        />
                                        <div className="absolute top-4 left-4 bg-blue-500 text-white text-xs px-2 py-1 rounded">
                                            Event Location
                                        </div>
                                    </div>
                                </div> */}
                            </div>

                            {/* Sidebar */}
                            <div className="w-full md:w-64 p-6 border-t md:border-t-0 md:border-l">
                                {/* <div className="mb-6">
                                    <button
                                        onClick={() => window.open(newEvent.values.trailer, "_blank")}
                                        className="w-full bg-blue-600 text-white py-2 px-4 rounded mb-2">
                                        Watch Trailer
                                    </button>
                                    <button className="w-full bg-white border border-blue-600 text-blue-600 py-2 px-4 rounded">
                                        Register Now
                                    </button>
                                </div> */}

                                <div className="mb-6">
                                    <h3 className="text-sm font-medium mb-3">Ticket Information</h3>

                                    {/* Event Type */}
                                    <div className="flex items-center mb-3">
                                        <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-2">
                                            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                        </div>
                                        <span className="text-sm">{newEvent.values.isFree ? "Free Event" : "Paid Event"}</span>
                                    </div>

                                    {/* Ticket Details - Only shown for ticketed events */}
                                    {newEvent.values.ticketType === "Ticketed Event" && (
                                        <div className="ml-8 space-y-3">
                                            {/* Ticket Name */}
                                            <div className="flex items-center">
                                                <span className="text-xs text-gray-500 w-24">Ticket Name:</span>
                                                <span className="text-sm">{newEvent.values.ticketName}</span>
                                            </div>

                                            {/* Ticket Price */}
                                            <div className="flex items-center">
                                                <span className="text-xs text-gray-500 w-24">Ticket Price:</span>
                                                <span className="text-sm font-medium">Rs.{newEvent.values.ticketPrice}</span>
                                            </div>

                                            {/* Ticket Category */}
                                            <div className="flex items-center">
                                                <span className="text-xs text-gray-500 w-24">Category:</span>
                                                <span className="text-sm">{newEvent.values.ticketCategory}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    const ProgressBar = () => {
        const steps = ['Edit', 'Banner', 'Ticketing'];
        return (
            <div className="relative mb-12">
                <div className="w-full h-[2px] bg-gray-200">
                    <div
                        className="h-full bg-blue-500 transition-all duration-300"
                        style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
                    />
                </div>
                <div className="absolute top-0 w-full flex justify-between transform -translate-y-1/2">
                    {steps.map((step, index) => (
                        <div key={step} className="flex flex-col items-center">
                            <div className={`w-4 h-4 rounded-full border-2 ${index + 1 <= currentStep ? 'bg-blue-500 border-blue-500' : 'bg-white border-gray-300'
                                }`} />
                            <span className="mt-2 text-sm text-gray-600">{step}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const handleOpen = async (id) => {
        setOpenDialogBox(true);
    };

    const closeDialogBox = () => {
        setOpenDialogBox(false);
    };

    const handleActionConfirm = async () => {
        setOpenDialogBox(false);
        Object.entries(draftEventData).forEach(([key, value]) => {
            newEvent.setFieldValue(key, value);
        });
    };

    return (
        <>
            <TailwindLayout>
                <TopBar />
                <div className="flex flex-col min-h-screen p-12 mb-8">
                    <div className="p-6 rounded-lg shadow-lg bg-white">
                        <h1 className="text-xl font-semibold mb-12">{id ? 'Edit Event' : 'Create New Event'}</h1>
                        {/* <Stepper currentStep={currentStep} /> */}
                        <ProgressBar />
                        {isEditLoading ? (
                            <div className="space-y-6">
                                {/* Title Skeleton */}
                                <div className="h-6 w-1/3 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                <div className="h-10 w-full bg-gray-200 rounded animate-pulse"></div>

                                {/* Unique Name Skeleton */}
                                <div className="h-6 w-1/3 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                <div className="h-10 w-full bg-gray-200 rounded animate-pulse"></div>

                                {/* Contact Email Skeleton */}
                                <div className="h-6 w-1/4 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                <div className="h-10 w-full bg-gray-200 rounded animate-pulse"></div>

                                {/* Contact Phone Skeleton */}
                                <div className="h-6 w-1/4 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                <div className="h-10 w-full bg-gray-200 rounded animate-pulse"></div>

                                {/* Category & Venue Skeleton */}
                                <div className="h-6 w-1/4 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                <div className="h-10 w-full bg-gray-200 rounded animate-pulse"></div>
                                <div className="h-6 w-1/4 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                <div className="h-10 w-full bg-gray-200 rounded animate-pulse"></div>

                                {/* Organization Skeleton */}
                                <div className="h-6 w-1/3 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                <div className="h-10 w-full bg-gray-200 rounded animate-pulse"></div>

                                {/* Date / Time Skeleton */}
                                {[...Array(2)].map((_, index) => (
                                    <div key={index} className="flex items-center gap-4">
                                        <div className="h-10 w-32 bg-gray-200 rounded animate-pulse"></div>
                                        <div className="h-10 w-32 bg-gray-200 rounded animate-pulse"></div>
                                        <div className="h-10 w-32 bg-gray-200 rounded animate-pulse"></div>
                                    </div>
                                ))}

                                {/* Registration Dates Skeleton */}
                                <div className="flex gap-4">
                                    <div className="h-10 w-32 bg-gray-200 rounded animate-pulse"></div>
                                    <div className="h-10 w-32 bg-gray-200 rounded animate-pulse"></div>
                                </div>

                                {/* Trailer & Tags Skeleton */}
                                <div className="h-6 w-1/4 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                <div className="h-10 w-full bg-gray-200 rounded animate-pulse"></div>
                                <div className="h-6 w-1/4 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                <div className="h-10 w-full bg-gray-200 rounded animate-pulse"></div>

                                {/* Description Skeleton */}
                                <div className="h-6 w-1/3 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                <div className="h-32 w-full bg-gray-200 rounded animate-pulse"></div>

                                {/* Sub Event Toggle Skeleton */}
                                <div className="h-6 w-1/4 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                <div className="h-8 w-14 bg-gray-200 rounded-full animate-pulse"></div>
                            </div>
                        ) : (
                            <form onSubmit={newEvent.handleSubmit} className="m-8">
                                {renderStepContent()}
                                <div className="mt-8 -mb-8 flex justify-end">
                                    <button
                                        type="button"
                                        onClick={handlePrevious}
                                        className={`px-6 py-2 mr-4 rounded-md hover:bg-blue-600 disabled:opacity-50 ${currentStep === 1
                                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed' // Disabled styles
                                            : 'bg-blue-500 text-white' // Enabled styles
                                            }`}
                                        disabled={currentStep === 1}
                                    >
                                        Previous
                                    </button>

                                    {currentStep === 3 ? (
                                        id ? (
                                            <button
                                                type="submit"
                                                className={`px-6 py-2 rounded-md hover:bg-blue-600 disabled:opacity-50 ${loading ? "bg-blue-400" : "bg-blue-500 text-white"}`}
                                                disabled={loading}
                                            >
                                                {loading ? "Updating..." : "Update Event"}
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className={`px-6 py-2 rounded-md hover:bg-blue-600 disabled:opacity-50 ${loading ? "bg-blue-400" : "bg-blue-500 text-white"}`}
                                                disabled={loading}
                                            >
                                                {loading ? "Publishing..." : "Publish Event"}
                                            </button>
                                        )
                                    ) : (
                                        <button
                                            type="button"
                                            onClick={handleNext}
                                            className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:opacity-50"
                                            disabled={isFirstStepLoading || isSecondStepLoading}
                                        >
                                            {isFirstStepLoading || isSecondStepLoading ? "Saving..." : "Next"}
                                        </button>
                                    )}



                                </div>
                                {(isFirstStepLoading ||
                                    isSecondStepLoading ||
                                    ticketCatImageLoading ||
                                    ticketCatAddLoading 
                                    ) && (
                                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                            <div className="bg-white p-4 rounded-lg flex flex-col items-center shadow-lg">
                                                <svg
                                                    className="animate-spin h-8 w-8 text-blue-600 mb-3"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                                    ></path>
                                                </svg>

                                                <p className="text-sm font-medium text-gray-700">Saving...</p>
                                            </div>
                                        </div>
                                    )}

                            </form>
                        )}
                    </div>
                </div>
                <FooterTailwind />
            </TailwindLayout>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <CommonModel
                open={openDialogBox}
                onClose={closeDialogBox}
                onAction={handleActionConfirm}
                text={'Do you want to continue with the draft event?'}
            />
            <SeatSetupModel
                open={seatSetupModelOpen}
                onClose={closeSeatSetupModel}
                capacity={newEvent.values.capacity}
                onSave={(seatData) => {
                    setSeatsData(seatData);
                    newEvent.setFieldValue('totalRows', seatData.rows);
                    newEvent.setFieldValue('totalSeatsPerRows', seatData.columns);
                }}
            />
            <SeatViewModel
                open={seatViewModelOpen}
                onClose={closeSeatViewModel}
                seatData={selectedVenueZone?.seats || []}
            />
        </>
    );
};

export default AddEventNew;